import {DRAWER} from "./drawer";
import {CARD} from "./card";
import {GTM, GTM4N} from "./gtm";
import {USER} from "./user";
import Cookies from 'js-cookie';
import IMask from 'imask';
import copy from 'copy-to-clipboard';

export const GLOBALS = {
    loaded_scripts: []
}

export const WARNING = {
    counter: 0,
    timeout_time: 2500,
    show: function(el) {
        this.counter++;
        el.addClass('warning-' + this.counter);
        setTimeout(() => {
            el.fadeOut('slow', () =>{
                el.remove()
            });
        }, this.timeout_time);
        $(".warningcontainer").prepend(el);
        el.show('normal');
    },

    info: function(text) {
        let el = $("<div></div>");
        el.addClass('warning warning-info');
        el.html(text);
        this.show(el);
    }
};

export const U = {

    awaitGrecaptchaResponse: async function() {
        const res = await new Promise((resolve, reject) => {
            U.loadscript(G.recaptcha_script, () => {
                resolve(grecaptcha.getResponse());
            });
        });

        return res;
    },

    slickBeautify: function(slick) {
        let _count = slick.$dots.find('li').length;
        let count = slick.$dots.find('li').length > 7 ? 7 : slick.$dots.find('li').length;

        $.each($("li", slick.$dots), function(i, item) {
            item = $(item);
            let classname = Math.round(count/_count * (i+1)) + '' + count;
            item.addClass('l'+classname);
        });
    },

    share: function(url, el) {
        this.copyToClipboard(url);
        TOOLTIP.open(el, {
            place: 'top',
            subclass: 'tooltip-black text-center tooltip-fadeinout',
            target: 'black',
            fadeinout: true
        });
    },

    bodyscroll: function(allow) {
        if (allow) {
            $("body, html").removeClass('disablescroll');
        } else {
            $("body, html").addClass('disablescroll');
        }
    },

    isset: function() {
        let a=arguments, l=a.length, i=0;

        if (l===0) {
            throw new Error('Empty isset');
        }

        while (i!==l) {
            if (typeof(a[i])=='undefined' || a[i]===null) {
                return false;
            } else {
                i++;
            }
        }
        return true;
    },

    mobileWidth: function() {
        return 580;
    },

    isMobile: function() {
        return this.viewportW() <= this.mobileWidth();
    },

    isLowScreen: function() {
        return $(window).width() >= 1260 && $(window).width() < 1440 ? true : false;
    },

    mask_inputs: function() {
        try {
            if ($(".phone-mask").length > 0) {
                let mask = IMask(document.querySelector('.phone-mask'), {
                    mask: '(000) 000-00-00'
                });
            }
        } catch(e) {console.error(e)};
    },

    IsInViewport: function(el) {
        if (typeof jQuery === "function" && el instanceof jQuery) el = el[0];
        let rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    },

    isInView: function(elem){
        if ($(elem).length && $(document).height() > 800) {
            // return $(elem).offset().top - $(window).scrollTop() < $(elem).height() ;
            return $(window).scrollTop() > ($(elem).offset().top - $(window).height()) ;
        }
        else
            return false;
    },

    showOrientationChangeAlert: function() {
        if (G.alert_change_orientation) {
            if ($(".u__orientationalert").length > 0) {
                $(".u__orientationalert").remove();
            } else {
                let style = this.viewportW() > this.mobileWidth() ? 'style="transform: scale(2.5)"' : ''; // && !U.isSafari()
                $("body").append(`<div class="u__orientationalert hiddenDesktop" ${style}>
                <div>
                    <h2>Сторінка буде оновлена</h2>
                    <button class="btn success" onclick="javascript: document.location.reload();" type="button">Перезавантажити</button>
                </div>
            </div>`);
            }
        } else {
            document.location.reload();
        }
    },

    viewportH: function() {
        return window.screen.height;
    },

    viewportW: function() {
        return window.screen.width;
    },

    isSafari: function() {
        return (navigator.userAgent.indexOf('Mac') != -1 && navigator.userAgent.indexOf('Chrome') == -1 && navigator.userAgent.indexOf('Firefox') == -1);
    },

    close_all: function(){
        this.bodyscroll(true);
        $(".main-container, .main-contain").removeClass('blur');
        $('.searchform').removeClass('searchform-focused');
        $(".hints").removeClass('show');
        $(".cart, .drawer, .mainmenu, .menubg-contain, .menubg").removeClass('show');

        if ($(".autocompleter").length)
            $(".autocompleter").remove();

        $(".js-popup-trigger").remove();
        $(".js-popup-trigger-hide").addClass('hidden');

        $(".drawer").removeClass('drawer-show drawer-opencity');
        $(".drawer__menuli-active").removeClass('drawer__menuli-active');
        $(".drawer-menu .screen").remove();
        $(".screen-main").removeClass('collapsed');
        $(".main-container > .user__menu, .header__right > .user__menu").removeClass('user__menu-visible').addClass('hidden');
        $(".mpc__tw").addClass('hidden');

        TOOLTIP.hide();

        CARD.close();
        DRAWER.destroy();
    },

    copyToClipboard: function(val) {
        return copy(val);
    },

    validate_email: function(email) {
        let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,6})+$/;
        return regex.test(email);
    },

    onlyUnique: function(value, index, self) {
        return self.indexOf(value) === index;
    },

    loadscript: function (name, callback) {
        if (U.in_array(name, GLOBALS.loaded_scripts, true)) {
            if (typeof callback==="function")
                callback();
        }
        else
            $.getScript( name ).done(function( script, textStatus ) {
                GLOBALS.loaded_scripts.push(name);
                if (typeof callback==="function")
                    callback();
            });
    },

    isMac: function() {
        return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    },

    postData: async function (data = {}, url = '/aj', timeout = 10000) {

        data.locale = G.locale_id;
        data.page = document.location.pathname;
        data.mobile = (U.isMobile()?1:0);

        AbortSignal.timeout ??= function timeout(ms) {
            const ctrl = new AbortController()
            setTimeout(() => ctrl.abort(), ms)
            return ctrl.signal
        }

        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            signal: AbortSignal.timeout(timeout),
            body: new URLSearchParams(data)
        });
        return response.json(); // parses JSON response into native JavaScript objects
    },

    replace_header: function()
    {
        if (this.isMobile()) {
            if (!HEADERSCROLL.blocked()) {

                var st = window.pageYOffset || document.documentElement.scrollTop;
                if (st > lastScrollTop) {
                    // downscroll code
                    if (!(lastScrollDirection == 'down')) {
                        lastScrollPositionCounter = 0;
                        lastScrollPosition = window.pageYOffset;
                    }

                    lastScrollDirection = 'down';
                    lastScrollPositionCounter++;

                    $(".header__top").addClass('header__top-fixed').removeClass('header__top-fake');
                } else {
                    // upscroll code
                    if (!(lastScrollDirection == 'up')) {
                        lastScrollPositionCounter = 0;
                        lastScrollPosition = window.pageYOffset;
                    }

                    lastScrollDirection = 'up';
                    lastScrollPositionCounter++;
                    lastScrollDiff = Math.abs(window.pageYOffset - lastScrollPosition);
                    lastScrollSpeedIndex = lastScrollDiff / lastScrollPositionCounter;

                    if (lastScrollSpeedIndex > 3) {
                        // short
                        // $(".header-middle").addClass('typical');
                    }

                    if (lastScrollSpeedIndex > 6 && lastScrollDiff > 200) {
                        // full
                        $(".header__top").addClass('header__top-fake');
                    }
                }
                lastScrollTop = st <= 0 ? 0 : st;

                if ($(window).scrollTop() < 1)
                    $(".header__top").removeClass('header__top-fixed header__top-semi header__top-fake');

                HEADERSCROLL.block();
            }
        }
    },

    blogGalleries: function() {
        if (!$(".jsplus_preview_href").length)
            return;

        let gallery_counter = 0;

        if ($(".text__content >p").length)
            $.each($(".text__content >p"), (ep, pp) => {
                pp = $(pp);
                if (pp.find('>.jsplus_preview_href').length) {

                    let images = [];
                    let html = '';
                    gallery_counter++;

                    $.each(pp.find(".jsplus_preview_href"), function(i, item) {
                        let wr = {};
                        item = $(item);

                        wr.thumb = item.find('img').attr('src');
                        wr.image = item.attr('href');
                        wr.alt = item.find('img').attr('alt');

                        images.push(wr);
                    });

                    let big = '';
                    let small = '';

                    $.each(images, function(i, image) {
                        big += '<div class="blog-gallery-big"><div loading="lazy" style="background-image: url(\''+image.image+'\')"><span class="alt">'+image.alt+'</span></div></div>';
                        small += '<div class="blog-gallery-small"><div loading="lazy" style="background-image: url(\''+image.thumb+'\')"></div></div>';
                    });

                    html = '<div class="blog-gallery-container"><div class="blog-gallery blog-gallery'+gallery_counter+'">'+big+'</div><div class="blog-gallery-nav hiddenMobile blog-gallery-nav'+gallery_counter+' '+(images.length < 5?'fixed-transform':'')+'">'+small+'</div></div>';
                    pp.replaceWith(html);

                    if (this.isMobile()) {
                        $('.blog-gallery'+gallery_counter).slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: true,
                            fade: true,
                            dots: true,
                        });
                    } else {

                        $('.blog-gallery'+gallery_counter).slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: true,
                            fade: true,
                            asNavFor: '.blog-gallery-nav'+gallery_counter
                        });

                        $('.blog-gallery-nav'+gallery_counter).slick({
                            slidesToShow: 5,
                            slidesToScroll: 2,
                            asNavFor: '.blog-gallery'+gallery_counter,
                            dots: false,
                            centerMode: true,
                            focusOnSelect: true
                        });

                    }

                }
            });
    },

    send_impressions: function() {
        // promo
        $('.js-gtm__promo').not('.js-gtm__promo-sended').each(function(){
            let el = $(this);

            if (U.IsInViewport(el) && el.is(':visible')) {
                el.addClass('js-gtm__promo-sended');
                GTM4N.event([
                    'view_promotion',
                    el.data()
                ]);
            }
        });

        // goods
        $('.for-impressions').not('.impressionSent').each(function(){
            let el = $(this);

            if (U.IsInViewport(el)) {
                el.addClass('impressionSent');
                GTM.event('show_impressions', el);
            }
        });

        $('.for-promogtm').not('.impressionSent').each(function(){
            let el = $(this);

            if (U.IsInViewport(el)) {
                el.addClass('impressionSent');
                GTM.event('show_pimpressions', el);
            }
        }).promise().done( function() {});
    },

    slickCatalogPromo: function(){

        if (!($(".promo-list .list a").length > 1)) {
            return;
        }

        $('.promo-list .list').slick({
            arrows:false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            autoplay: $('.main-slider').data('scroll') ? true : false,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 1260,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 769,
                    settings: "unslick"
                }
            ]
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            U.slickBeautify(slick);
        }).on('afterChange', function(event, slick, currentSlide, nextSlide){
            U.send_impressions();
        });
    },

    open_supportman_subscribe: function() {
        let classes = ['default', 'top', 'middle'];
        let place = classes[Math.floor(Math.random() * Math.floor(3))];

        TOOLTIP.open($('.open-supportman'), {
            target: '.supportman-subscribe',
            place: 'top',
            subclass: 'supportman-subscribe ' + place,
            fixed: true
        });

        $(".open-subscribe-chat").data('to', place);
        GTM.event('subscribe_popup', place);
    },

    init_full_size_gallery: function() {
        if ($(".full-size-gallery").length) {

            $(".full-size-gallery").slick({
                speed: 1000,
                arrows: false,
                asNavFor: '.full-size-gallery-small'
            });

            $(".full-size-gallery-small").slick({
                slidesToShow: 5,
                speed: 1000,
                infinite: true,
                asNavFor: '.full-size-gallery',
                // centerMode: true,
                dots: false,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            centerMode: false,
                        }
                    }
                ]
            });
        }
    },

    fix_store_content: function() {
        if (!this.isMobile() && $(".store__contain").length) {
            let newheight = $(".store__content").outerHeight();
            if (newheight > 600)
                $(".store__contain").css('min-height', newheight);
        }
    },

    in_array: function(needle, haystack) {
        let length = haystack.length;
        let i = 0;
        for(i = 0; i < length; i++) {
            if(haystack[i] == needle) return true;
        }
        return false;
    }

}

export const CATALOG = {
    promo_slider_timeout: false,
    reset_promo_slider: function() {
        clearTimeout(CATALOG.promo_slider_timeout);
        if (!U.isMobile() && $(".promo__tagnav-down").length > 0)
            CATALOG.promo_slider_timeout = setTimeout(function() {
                $(".promo__tagnav-down").trigger('click');
            }, 5000);
    },

    updateSeo(title, text)
    {
        if (title!='' || text!='') {
            if ($(".container.seo").length == 0) {
                $(`<div class="container seo lm">
                <div class="wrapper">
                    <article class="short"></article>                
                    <a href="javascript: void(null);" class="toggle-seo">Переглянути повністю</a>
                </div>
            </div>`).insertBefore("footer");
            }

            $(".container.seo article").empty();

            if (title != '') {
                $(".container.seo article").append(`<h2>${title}</h2>`);
            }

            $(".container.seo article").append(text);
        } else {
            $(".container.seo").remove();
        }
    }
}

export const CHAT = {
    loaded: false,
    opened_chats: {
        chat: false
    },

    update_cookies: function() {
        Cookies.set('chat_settings', JSON.stringify(this.opened_chats));
    },

    load_cookies: function() {
        let str = Cookies.get('chat_settings');
        if (typeof str === "string") {
            let data = JSON.parse(str);
            this.opened_chats = {...this.opened_chats, ...data};
        }
    },

    load: function() {
        $(".open-supportman").addClass('open-supportman-loading');

        window.helpcrunchSettings = {
            organization: 'ktcua',
            showWidget: false,
            openWidget: false
        };

        let loading = function() {
            return new Promise((resolve, reject) => {
                (function (w, d) {

                    if (!CHAT.loaded) {

                        w.HelpCrunch = function () {
                            w.HelpCrunch.q.push(arguments)
                        };
                        w.HelpCrunch.q = [];

                        function r() {
                            let s = document.createElement('script');
                            s.async = 1;
                            s.type = 'text/javascript';
                            s.src = 'https://embed.helpcrunch.com/sdk.js';
                            s.onload = () => resolve();
                            (d.body || d.head).appendChild(s);
                        }

                        r();

                        CHAT.loaded = true;
                    } else {
                        resolve();
                    }
                })(window, document);
            });
        };

        return loading()
            .then(() => {
                HelpCrunch('init', 'ktcua',
                    {
                        organization: 'ktcua',
                        appId: 'd5d5c468-8b38-4b44-a67a-892498a479b0',
                        showWidget: false,
                        openWidget: false
                    }
                );

                HelpCrunch('setPhraseList', 'uk ');

                if (G.client && G.client.name) {
                    HelpCrunch('updateUser', {
                        name: G.client.name,
                        email: G.client.email ?? '',
                        phone: G.client.phone ?? '',
                        user_id: G.client.code > 0 ? G.client.code : `0_${G.client.id}`,
                        custom_data: {
                            city: G.client.city ?? ''
                        }
                    });
                }

                this.check_unread_messages();
            })
            .finally(() => {
                setTimeout(() => {
                    $(".open-supportman").removeClass('open-supportman-loading');
                }, 1500);
                TOOLTIP.hide();
            });
    },

    open: function(message = '') {
        this.load()
            .then(() => {
                this.opened_chats.chat = true;
                this.update_cookies();

                HelpCrunch('openChat');

                if (message!='')
                    HelpCrunch('sendUserMessage', message);
        });
    },

    check_unread_messages: function() {
        HelpCrunch('onNewUnreadChat', function (event) {
            if (event.unreadChats) {
                $(".open-supportman .inner-text").html(`<div class="pseudo"></div>Нове повідомлення`);
                $(".open-supportman").addClass('show').addClass('open-supportman-triggerchat');
            } else {
                $(".open-supportman .inner-text").html(`<div class="pseudo"></div>Привіт! Допомогти ?`);
                $(".open-supportman").removeClass('open-supportman-triggerchat');
            }
        });
    },

    check_messages: function() {
        this.load_cookies();
        if (this.opened_chats.chat && !G.manager_logged) {
            this.load();
        }
    }
}

export const BROWSE = {
    limit: 50,
    started: false,
    queue_price: [],
    price_load_timeout: false,
    price_load_timeout_time: 700,

    set: function(key, data) {
        if (key && typeof data === "object")
            localStorage.setItem(key, JSON.stringify(data));
        
        this.clean_old();
    },

    clean_old: function() {
        let list = [];
        let cc = 0;

        if (localStorage.length)
            for (var key in localStorage)
                if (key.substr(0, 6) == 'goods_') {
                    list[key.substr(6)] = JSON.parse(localStorage.getItem(key));
                }

        list.sort(function (a, b) {
            if (a.ts == b.ts)
                return 0;
            else
                return a.ts > b.ts ? -1 : 1;
        });

        $.each(list, function (key, item) {
            if (typeof item === "object") {
                cc++;
                if (cc > BROWSE.limit)
                    localStorage.removeItem('goods_' + item.sid);
            }
        });
    },

    count_str: function(len) {
        len = len.toString();
        let suffix = '';

        switch (len) {
            case '1':
                suffix = len.substr(-2, 2) == '11' ? __('товарів') : __('товар');
                break;
            case '2':
                suffix = len.substr(-2, 2) == '12' ? __('товарів') : __('товари');
                break;
            case '3':
                suffix = len.substr(-2, 2) == '13' ? __('товарів') : __('товари');
                break;
            case '4':
                suffix = len.substr(-2, 2) == '14' ? __('товарів') : __('товари');
                break;
            default:
                suffix = __('товарів');
                break;
        }

        return len + ' ' + suffix;
    },

    lastseen: function() {
        if (!this.started) {
            this.started = true;

            var list = [];
            var sku_list = [];
            var cc = 0;

            if (localStorage.length)
                for (var key in localStorage)
                    if (key.substr(0, 6) == 'goods_') {
                        list[key.substr(6)] = JSON.parse(localStorage.getItem(key));
                    }

            list.sort(function (a, b) {
                if (a.ts == b.ts)
                    return 0;
                else
                    return a.ts > b.ts ? -1 : 1;
            });

            $.each(list, function (key, item) {
                if (typeof item === "object") {
                    cc++;

                    if (cc > BROWSE.limit) {
                        localStorage.removeItem('goods_' + item.sid);
                    }
                    else {
                        sku_list.push(item.sid);
                    }
                }
            });

            $.post(
                '/aj',
                {
                    action: 'u',
                    to: 'lastseen',
                    locale: G.locale_id,
                    sku: sku_list.join(',')
                },
                function (data) {
                    $(".browse__content").removeClass('load-animation');
                    if (typeof data.goods === "object")
                        $.each(data.goods, function(i, html) {
                            $(".looplist").append(html);
                        });
                },
                'json'
            );

        }
    },

    fill: function() {
        if (!this.started) {
            this.started = true;
            var list = [];
            var result = [];
            var sku_list = [];
            var cc = 0;

            if (localStorage.length)
                for (var key in localStorage)
                    if (key.substr(0, 6) == 'goods_') {
                        list[key.substr(6)] = JSON.parse(localStorage.getItem(key));
                    }

            list.sort(function (a, b) {
                if (a.ts == b.ts)
                    return 0;
                else
                    return a.ts > b.ts ? -1 : 1;
            });

            $.each(list, function (key, item) {
                if (typeof item === "object") {
                    cc++;

                    if (cc > this.limit)
                        localStorage.removeItem('goods_' + item.sid);
                    else {
                        result.push(item);
                        sku_list.push(item.sid);
                    }
                }
            });

            this.html(result);
            // this.load_prices(sku_list);
        }
    },

    load_queue_prices: function() {
        if (this.queue_price.length) {
            clearTimeout(BROWSE.price_load_timeout);
            let skulist = this.queue_price;
            BROWSE.queue_price = [];
            $.post(
                '/aj',
                {
                    action: 'u',
                    to: 'browse',
                    locale: G.locale_id,
                    sku: skulist.join(',')
                },
                function (data) {
                    if (typeof data === "object" && Object.keys(data).length)
                        $.each(data, function(sku, value) {
                            let price_output = (!(value.price_old == '0') ? '<del>' + value.price_old + '</del>' : '') + value.price + '&nbsp;' + value.currency;
                            let html = '';

                            if (value.price=='0') {
                                if (value.preorder) {
                                    html = `<div class="viewedlist__sticker viewedlist__sticker-preorder">${value.preorder_text}</div>`;
                                } else {
                                    html = '<div class="viewedlist__sticker viewedlist__sticker-sold">' + __('Немає в наявності') + '</div>';
                                }

                                $(".viewedlist__item[data-sid=" + sku + "] .viewedlist__price").addClass('viewedlist__price-sold');
                            } else {
                                html = '<span>' + price_output + '</span>';
                                if (value.outlet)
                                    html = '<div class="viewedlist__sticker viewedlist__sticker-outlet">' + __('Уцінка') + '</div>' + html;
                            }

                            if (!(value.price_old == '0'))
                                $(".viewedlist__item[data-sid=" + sku + "] .viewedlist__price").addClass('viewedlist__price-promo');

                            $(".viewedlist__item[data-sid=" + sku + "] .viewedlist__price").html(html);
                        });
                },
                'json'
            );
        }
    },

    ping_load_prices: function(item) {
        clearTimeout(this.price_load_timeout);
        this.queue_price.push(item.parents('.viewedlist__item').data('sid'));
        this.price_load_timeout = setTimeout(() => {this.load_queue_prices()}, this.price_load_timeout_time);
    },

    html: function(items) {
        if (typeof items === "object" && Object.keys(items).length > 0) {
            $.each(Object.values(items), function (i, item) {
                if (item.i) {
                    const origin_ext = item.i.toString().slice((item.i.lastIndexOf(".") - 1 >>> 0) + 2);
                    const webp_path = item.i.replace(/\.\w+$/, '.webp');

                    $(".container-lastseen .viewedlist").append(`
                    <div class="viewedlist__outer">
                        <div class="viewedlist__item" data-sid="${item.sid}">
                            <a class="viewedlist__image" href="${item.l}">
                                <picture>
                                    <source type="image/webp" srcset="${webp_path}" />
                                    <source type="image/${origin_ext}" srcset="${item.i}" />
                                    <img loading="lazy" />
                                </picture>
                            </a>
                            <div class="viewedlist__title"><a href="${item.l}">${item.t}</a></div>
                            <div class="viewedlist__price"></div>
                        </div>
                    </div>`
                    );
                }
            });

            $('.viewedlist__image img').on('load', function() {
                BROWSE.ping_load_prices($(this));
            });
        }
        else
            $(".container-lastseen").remove();
    },

    load_prices: function(sku) {
        if (typeof sku === "object" && sku.length)
            $.post(
                '/aj',
                {
                    action: 'u',
                    to: 'browse',
                    locale: G.locale_id,
                    sku: sku.join(',')
                },
                function (data) {
                    if (typeof data === "object" && Object.keys(data).length)
                        $.each(data, function(sku, value) {
                            var price_output = (!(value.price_old == '0') ? '<del>' + value.price_old + '</del>' : '') + value.price + '&nbsp;' + value.currency;

                            if (value.price=='0') {
                                price_output = __('Немає в наявності');
                                $(".container-lastseen .viewedlist__item[data-sid=" + sku + "] .viewedlist__price").addClass('viewedlist__price-sold');
                            }

                            var html = '<span>' + price_output + '</span>';

                            if (value.outlet)
                                html = '<span class="outlet-discount">' + __('Уцінка') + '</span>' + html;

                            $(".viewedlist__item[data-sid=" + sku + "] .viewedlist__price").html(html);
                        });
                },
                'json'
            );
    },

    sliderBrowse: function() {
        this.fill();

        if ($('.container-lastseen .viewedlist:not(.unslick):not(.slick-initialized)').length)
            $('.container-lastseen .viewedlist:not(.unslick):not(.slick-initialized)').slick({
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: false,
                nextArrow: '<button type="button" class="viewedlist__next"></button>',
                prevArrow: '<button type="button" class="viewedlist__prev"></button>',
                responsive: [
                    {
                        breakpoint: 1500,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1340,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: "unslick"
                    }
                ]
            });
    }

}

export const SEARCH = {
    searchautocomplete_index: -1,
    timeouttime: 500,
    search_history: [],
    timeout: false,
    key: 'AIzaSyB3mc3CbaLk9mf0rDJ6X9r8R6UtgiUvtVc',

    clean_form: function() {
        $(".searchform [type=text]").val('').trigger('reset').trigger('keyup');
        // $(".autocompleter").remove();
    },

    load_history: function() {
        this.search_history = JSON.parse(localStorage.getItem('search_history'));
        this.search_history = this.search_history ? this.search_history :  [];
    },

    push_history: function(val) {
        this.load_history();
        val = $.trim(val);

        if (this.search_history.indexOf(val) == -1) {
            this.search_history.push($.trim(val));
            this.search_history = this.search_history.filter(U.onlyUnique);
        }
        this.search_history = this.search_history.slice(Math.max(this.search_history.length - 5, 0))
        localStorage.setItem('search_history', JSON.stringify(this.search_history));
    },

    get_history: function() {
        this.load_history();
        return this.search_history.reverse();
    },

    encryptStringWithXORtoHex: function(string, key) {
        string = string.split('');
        key = key.split('');
        var str_len = string.length;
        var key_len = key.length;
        var String_fromCharCode = String.fromCharCode;

        for(var i = 0; i < str_len; i++) {
            string[i] = String_fromCharCode(string[i].charCodeAt(0) ^ key[i % key_len].charCodeAt(0));
        }

        return string.join('');
    },

    fix_autocomplete_position: function() {
        if (U.isMobile()) {
            if ($(".autocompleter.show").length)
                $(".autocompleter").css('top', $(".header__top").height() - (G.portalid==7 ? 0 : 16));
        } else {
            $(".autocompleter").css('width', $(".searchform").width());
            $(".autocompleter").css('left', $(".searchform").position().left);
            return;
        }

    },

    postData: async function (data = {}, url = '/search/autocomplete') {
        data.locale = G.locale_id;
        Object.assign(data, this.extend_params);

        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-requested-with': 'XMLHttpRequest'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: new URLSearchParams(data)
        });
        return response.json();
    },

    process_search: function(input, mobile) {
        this.searchautocomplete_index = -1;

        $('.searchform [name=qq]').val(input.val());

        let val = $.trim(input.val()).split(' ');
        val.pop();
        let str = val.join(' ');
        str = str!=='' ? str + ' ' : '';

        SEARCH.fix_autocomplete_position();

        $('.autocompleter').addClass('autocompleter-loading');
        
        this.postData({
            q: input.val(),
        }).then((data) => {
            $('.autocompleter').empty();
            $(".hints").removeClass('show');

            if (data.result.length) {
                $('.autocompleter').append('<div class="autocompleter__list"></div>');
                let counter = 0;
                $.each(data.result, (index, link) => {
                    counter++;

                    if ((!U.isMobile()) || (U.isMobile() && counter < 5))
                        if (!U.isLowScreen() || (U.isLowScreen() && counter < 5))
                            $('.autocompleter__list').append('<a href="#" data-q="' + str + link.t + '" class="autocompleter__a autocompleter__a-arrow js-autocompleter__a">' + str + link.text + '</a>');
                });

                if (G.channel!=7) {
                    if (typeof data.search === "object" && data.search.length) {
                        let html = '<div class="autocompleter__list"><span class="autocompleter__listtitle">' + __('Пошук у категорії') + '</span>';
                        let counter = 0;

                        $.each(data.search, (i, item) => {
                            counter++;
                            html += `<a href="${item.url}" class="autocompleter__a autocompleter__a-go ${counter<=3?'':'hidden'}"><span>${item.title}</span>&nbsp;&nbsp;(${item.qty})</a>`;
                        });

                        if (data.search.length > 3) {
                            html += `<a href="javascript: void(null);" class="autocompleter__more js-autocompleter__more typical typical-plus">Показати більше</a>`;
                        }

                        html += '</div>';
                        $('.autocompleter').append(html);
                    }

                    if (typeof data.categories === "object" && data.categories.length) {
                        let html = `<div class="autocompleter__list"><span class="autocompleter__listtitle">${__('Перейти у категорію')}</span>`;
                        let counter = 0;

                        $.each(data.categories, (i, item) =>  {
                            counter++;
                            html += `<a href="${item.url}" class="autocompleter__a autocompleter__a-go ${counter<=3?'':'hidden'}"><span>${item.title}</span></a>`;
                        });

                        if (data.categories.length > 3) {
                            html += `<a href="javascript: void(null);" class="autocompleter__more js-autocompleter__more typical typical-plus">Показати більше</a>`;
                        }

                        html += '</div>';
                        $('.autocompleter').append(html);
                    }

                } else
                    SEARCH.append_history();

            } else {
                $('.autocompleter').html('<div class="autocompleter__list"><a href="javascript: void(null);" class="autocompleter__a autocompleter__a-unsearch">' + __('Нічого не знайдено') + '</a></div>');
            }
            $('.autocompleter').addClass('show');
        }).finally(() => {
            $('.autocompleter').removeClass('autocompleter-loading');
        });
    },

    ping_search: function(input, mobile) {

        clearTimeout(SEARCH.timeout);

        if ($('.autocompleter').length==0)
            $(".main-container").append('<div class="autocompleter"></div>');

        if ($.trim(input.val()).length > 2) {
            SEARCH.timeout = setTimeout(function() {
                SEARCH.process_search(input, mobile);
            }, SEARCH.timeouttime);
        } else {
            // history

            $('.autocompleter').empty();
            this.append_history();
            SEARCH.fix_autocomplete_position();
        }
    },

    append_history: function() {
        let history = this.get_history();
        if (history.length > 0) {
            let app = $("<div></div>").addClass('autocompleter__list');

            if (G.portalid==7)
                app.append('<span class="autocompleter__listtitle">' + __('Історія пошуку') + '</span>');

            $.each(history, function(i, item){
                app.append('<a href="#" data-q="' + item + '" class="autocompleter__a autocompleter__a-lupe js-autocompleter__a">' + item + '</a>');
            });

            app.appendTo($('.autocompleter'));
            $('.autocompleter').addClass("show");
        }
    },

    load_tab: function(tab, offset = 0)
    {
        let tab_container = $(`.js-searchtab[data-tab=${tab}]`);
        let btn = $(`.js-search__switchtab[data-id=${tab_container.data('id')}]`);

        console.log(tab);
        if (offset == 0) {
            $(".js-search__switchtab").removeClass('active ctabs__a-active');
            btn.addClass('active ctabs__a-active');
            $(`.js-searchtab`).addClass('hidden');
            tab_container.data('offset', '0').removeClass('hidden');
        }

        if (tab!='catalog') {
            $(".catalog__mobsorting").addClass('hidden');
            if (offset == 0) {
                tab_container.addClass('search__switchtab-loading');
            }

            let offset = parseInt(tab_container.data('offset'));
            let limit = 12;

            $.post(
                '/aj',
                {
                    action: 'search',
                    to: 'tab',
                    locale: G.locale_id,
                    obj_type: btn.data('id'),
                    query: G.filter.search_query ?? '',
                    offset: offset
                },
                function (data) {
                    if (offset == 0) {
                        tab_container.removeClass('search__switchtab-loading').html(data.html);
                    } else {
                        tab_container.find('.js-search__tabappend').append(data.html);
                    }

                    offset += limit; // + limit
                    tab_container.data('offset', offset);

                    tab_container.find('.show-more').remove();

                    if (data.total > offset) {
                        tab_container.append(`<a href="javascript: void(null);" class="show-more show-more-searchtab js-search__tabshowmore" data-tab="${tab}" data-page="${offset}">Показати ще</a>`);
                    }
                },
                'json'
            );
        } else {
            $(".catalog__mobsorting").removeClass('hidden');
            $(".js-search__switchtab[data-tab=catalog]").addClass('active ctabs__a-active');
        }
    }

}

export const LOOP = {
    imagestimeouttime: 2000,
    imagestimeout: false,
    imagesloop: false,

    clean_timeout: function(){
        clearTimeout(this.imagestimeout);
        this.imagesloop = false;
    },

    start_timeout: function(loop){
        if (loop)
            this.imagesloop = loop;

        if (this.imagesloop && this.imagesloop.find('.loop__image picture').length > 1)
            this.imagestimeout = setTimeout(() => {
                this.slide_image()
            }, this.imagestimeouttime);
    },

    slide_image: function() {
        clearTimeout(this.imagestimeout);

        if (this.imagesloop) {
            let img = this.imagesloop.find('.loop__image picture:not(.hidden)');
            let next = (img.next().length) ? img.next() : this.imagesloop.find('.loop__image picture:eq(0)');

            img.animate(
                {
                    opacity: 0
                },
                200,
                () => {
                    img.addClass('hidden')
                    next.removeClass('hidden').animate({opacity: 1}, 200, () => {
                        this.start_timeout();
                    });
                }
            );
        }
    }
}

export const COMPARSION = {
    loaded: false,
    key: 'comparsion',
    action: G.manager_logged ? 'slr' : 'users',
    sku: new Map(),
    __is_from_url: false,

    sku_from_url: function() {
        let segment = document.location.pathname.split('/compare/');
        let skus = (segment[1] ?? '').toString().split(',');
        return skus.filter((sku) => parseInt(sku));
    },

    load_from_url: function() {
        this.sku = new Map();
        let skus = this.sku_from_url();

        skus.map((sku) => {
            this.sku.set(parseInt(sku), {
                sku: sku,
                context: 0
            });
        });
        this.loaded = true;
        this.__is_from_url = true;
    },
    is_from_url: function() {
        return this.__is_from_url;
    },
    hover: function(btn) {
        if (btn.hasClass('ri-compare-active')) {
            if (this.context_count(btn.data('sku')) > 1) {
                TOOLTIP.open(btn, {
                    target: '.ri__comparehover-filled',
                    place: 'bottom',
                    subclass: 'tooltip-compare'
                });
            }
        }
        else {
            TOOLTIP.open(btn, {
                target: '.ri__comparehover',
                place: 'bottom',
                subclass: 'tooltip-compare'
            });
        }
    },

    load_page: function(context_id) {
        this.load();

        $(".comparsion__container").empty().addClass('load-animation');

        $.post(
            '/aj',
            {
                action: 'u',
                to: 'compare',
                locale: G.locale_id,
                comparsion: Array.from(this.sku.keys()).join(','),
                public: this.is_from_url() ? 1 : 0,
                context_id: context_id
            },
            (data) => {
                $(".comparsion__container").removeClass('load-animation').html(data.html);
                $(".js__sharebtn").data('url', data.publicurl);
                $(".comparsion__header").removeClass('hidden')

                if (!this.is_from_url()) {
                    $(".header__top").removeClass('header__top-usermenu');
                    $(".comparsion__header .ctabs").remove();
                    $(".comparsion__header").prepend(data.ctabs);
                    $(".header__bottom").remove();

                    if (data.ctabs && U.isMobile()) {
                        $(".header__top").append('<div class="header__bottom">' + data.ctabs + '</div>').addClass('header__top-usermenu').find('.ctabs').addClass('scroll-horizontal');

                        $(".ctabs.scroll-horizontal").animate({
                            scrollLeft: $(".ctabs__a-active").position().left - 16
                        }, 100);
                    }
                }

                if ($(".comparsion__table .item").length) {
                    $.each($(".comparsion__table .item"), function (i, loop) {
                        loop = $(loop).find('>.head >.title');

                        GTM.event('push_product_details', {
                            list: 'compare',
                            name: loop.data('name'),                      // Name or ID is required.
                            sku: loop.data('sku'),
                            price: loop.data('price'),
                            brand: loop.data('brand'),
                            category: loop.data('category'),
                            variant: loop.data('variant')
                        }, 0, 'compare', '');

                        GTM.event('show_impressions', loop);
                    });
                    $(".comparsion__buttons").removeClass('hidden');
                } else {
                    $(".comparsion__buttons").addClass('hidden');
                }

                this.hook_after_load();
            },
            'json'
        );
    },

    hook_after_load: function() {
        $(".header__top").find(`.comparsion__table`).remove();
        if (U.isMobile()) {
            $(".header__top").addClass('header__top-comparison').append(`
                <div class="comparsion__table hidden js-comparsion__table">
                </div>
            `);
        } else {
            $(".header__top").addClass('header__top-comparison').append(`
                <div class="comparsion__table hidden">
                    <div class="wrapper wrapper-compare clearfix">
                        <a href="#" class="comparsion-scroll comparsion-scroll-active right hiddenMobile"></a>
                        <a href="#" class="comparsion-scroll left hiddenMobile"></a>
                        <div class="scroll js-comparsion__table">
                            
                        </div>
                    </div>
                </div>
            `);
        }

        $.each($(".cabinet .comparsion__table .head"), function(i, item) {
            let _item = $(`<div class="item"></div>`);
            let clone = $(item).clone();
            _item.append(clone).appendTo('.header__top-comparison .js-comparsion__table');
        });

        this.sticky_scroll();
    },

    sticky_scroll: function() {
        const sentinel = $(".comparsion__table >.scroll");
        const scroll_element = $(".cabinet .comparsion__table .scroll");

        const minTop = $(".cabinet .comparsion__table").offset().top - (U.isMobile() ? 145 : 60);
        const maxTop = minTop + $(".cabinet .comparsion__table").height() - $(".cabinet .comparsion__table .head").height() - (U.isMobile() ? 100 : 100);

        const sticky_table = $(".header__top .comparsion__table");
        const sticky_table_scroll = $(".js-comparsion__table");

        scroll_element.scroll(function(e) {
            // console.log(scroll_element.scrollLeft());
            sticky_table_scroll.scrollLeft(scroll_element.scrollLeft()); //fix the thead relative to the body scrolling
        });

        window.addEventListener('scroll', () => {
            const scrollY = window.scrollY;

            if (scrollY >= minTop && scrollY <= maxTop) {
                // sticky.css('top', `${scrollY - topOffset + 16}px`);
                // scrolls.css('top', `${scrollY - topOffset + 16 + 72}px`);
                sticky_table.removeClass('hidden');
                sticky_table_scroll.scrollLeft(scroll_element.scrollLeft());
            } else {
                // sticky.css('top', '0px');
                // scrolls.css('top', '72px');
                sticky_table.addClass('hidden');
            }
        });
    },

    context_count: function(sku) {
        let count = 0;
        let context = 0;
        sku = parseInt(sku);

        if (this.sku.get(sku)) {
            context = this.sku.get(sku).context;
            if (context) {
                this.sku.forEach((sku) => {
                    if (sku.context == context)
                        count++;
                });
            }
        }

        return count;
    },

    load: function(force) {
        if (!this.loaded || force) {
            this.loaded = true;
            let list = localStorage.getItem(this.key);
            list = typeof list === "string" ? list : '';
            this.sku.clear();

            if (list.substr(0, 1)=='[') {
                // json
                try {
                    list = JSON.parse(list);
                    if (typeof list === "object" && list.length > 0)
                        $.each(list, (i, sku) => {
                            if (typeof sku === "object") {
                                this.sku.set(parseInt(sku.sku), sku);
                            }
                        });
                } catch (e){};
            } else {
                list = typeof list === "string" ? list.split(',') : [];
                if (list.length)
                    $.each(list, (i, sku) => {
                        if (parseInt(sku)) {
                            this.sku.set(parseInt(sku), {
                                sku: sku,
                                context: 0
                            });
                        }
                    });
            }

        }
    },

    set_storage: function() {
        let write = [];
        this.sku.forEach((sku) => {
            if (typeof sku === "object")
                write.push(sku);
        });
        localStorage.setItem(this.key, JSON.stringify(write));
    },

    count: function() {
        this.load();
    },

    clean: function() {
        this.load();
        this.sku.clear();
        this.set_storage();

        if (USER.is_logged() || G.b2bmode || G.manager_logged)
            this.synchronize(1);

        this.update_anchors();
    },

    remove: function(sku) {
        this.load();
        sku = parseInt(sku);
        if (sku) {
            if (this.sku.get(sku))
                this.sku.delete(sku);

            this.set_storage();

            if (USER.is_logged() || G.b2bmode || G.manager_logged)
                this.synchronize(1);
            else
                this.update_anchors();
        }
    },

    addpack: function(skus) {
        this.load(true);
        skus.map((sku) => {
            this.sku.set(parseInt(sku), {
                sku: sku,
                context: 0
            });
        });

        if (USER.is_logged() || G.b2bmode  || G.manager_logged)
            this.synchronize();
        else {
            this.set_storage();
        }
    },

    add: function(sku, context_id, btn, callback) {
        this.load(true);
        sku = parseInt(sku);

        if (sku) {
            let remove = 0;
            if (!this.sku.get(sku)) {
                this.sku.set(parseInt(sku), {
                    sku: sku,
                    context: context_id
                });
                if (btn)
                    GTM.event('product_click', btn, 0, 'compare', '');
            }
            else {
                remove = 1;
                this.sku.delete(sku)
            }

            if (USER.is_logged() || G.b2bmode  || G.manager_logged)
                this.synchronize(remove, callback);
            else {
                this.set_storage();
                this.update_anchors(true);

                if (typeof callback==="function")
                    callback();
            }

        }
    },

    synchronize: function(remove, callback) {
        this.load();

        $.post(
            '/aj',
            {
                action: this.action,
                to: 'compare',
                locale: G.locale_id,
                comparsion: Array.from(this.sku.keys()).join(','),
                remove: remove
            },
            (data) => {
                this.sku.clear();
                data = typeof data === "string" ? data.split(',') : [];

                if (data.length)
                    $.each(data, (i, sku) =>{
                        let _sku = sku.split(':');
                        if (parseInt(_sku[0])) {
                            this.sku.set(parseInt(_sku[0]), {
                                sku: _sku[0],
                                context: _sku[1] ? _sku[1] : 0
                            });
                        }
                    });

                this.set_storage();
                this.update_anchors();

                if (typeof callback === "function")
                    callback();
            }
        );
    },

    clean_context: function(context_id, callback) {
        $.post(
            '/aj',
            {
                action: this.action,
                to: 'compare',
                locale: G.locale_id,
                clean_context: context_id
            },
            (data) => {
                this.sku.clear();
                data = typeof data === "string" ? data.split(',') : [];

                if (data.length)
                    $.each(data, (i, sku) => {
                        let _sku = sku.split(':');
                        if (parseInt(_sku[0])) {
                            this.sku.set(parseInt(_sku[0]), {
                                sku: _sku[0],
                                context: _sku[1] ? _sku[1] : 0
                            });
                        }
                    });

                this.set_storage();
                this.load(true);
                this.synchronize(1);
                this.update_anchors();

                if (typeof callback === "function")
                    callback();
            }
        );
    },

    update_anchors: function(animation) {
        this.load();
        $(".ri-compare").removeClass('ri-compare-active').data('target', '.ri__comparehover');
        $(".icon-compare a span").remove();
        $(".hb__uicon-compare span").remove();

        if (this.sku.size) {
            $(".icon-compare a").append('<span>' + this.sku.size + '</span>');
            $(".hb__uicon-compare").append('<span>' + this.sku.size + '</span>');

            this.sku.forEach((sku) => {
                if (typeof sku === "object")
                    $(".ri-compare[data-sku=" + sku.sku + "]").addClass('ri-compare-active').data('target', '.ri__comparehover-filled');
            });
        }

        this.opacity_ri();
    },

    opacity_ri: function() {
        $(".loop__ri-active").removeClass('loop__ri-active');

        if ($(".ri-compare-active, .ri-wishlist-active").length > 0)
            $.each($(".ri-compare-active, .ri-wishlist-active"), function(i, item) {
                item = $(item);
                item.parent().addClass('loop__ri-active');
            });
    }
}

export const CITY = {
    loading: false,
    delete_city: function(callback) {
        $.ajax({
            type: "POST",
            url: "/aj",
            data: {
                action: 'u',
                to: 'unsetcity',
                locale: G.locale_id
            },
            dataType: "json",
            timeout: 5000, // in milliseconds
            success: function(data) {
                $(".header__city").html('<span>' + __('Оберіть місто') + '</span>');
                $(".drawer__menuli-city >a").html(__('Оберіть місто'));

                if (typeof callback === "function")
                    callback();
            },
            error: function(data){
            }
        });
    },

    set_city: function(id, title, callback)
    {
        let date = new Date();
        date.setTime(date.getTime() + (60*60*24*31 * 1000));

        Cookies.set("city", id + ':' + title, {
            path    : '/',
            expires: date
        });

        $(".header__city").html('<span>' + title + '</span>');
        $(".drawer__menuli-city >a").html(__('Місто') + '<span>' + title + '</span>');

        $.post(
            '/aj',
            {
                action: 'u',
                to: 'savecity',
                city_id: id,
                locale: G.locale_id
            },
            (data) => {
                this.event_listener();

                if (typeof callback === "function")
                    callback();
                else
                    document.location.reload();
            },
            'json'
        );
    },
    
    load_popup: function(callback)
    {
        if ($(".drawer__menuli-city").hasClass('drawer__menuli-city-loaded')) {
            if (typeof callback === "function")
                callback();
        } else {
            $.post(
                '/aj',
                {
                    action: 'u',
                    to: 'citychoise',
                    locale: G.locale_id
                },
                (data) => {
                    $(".drawer__menuli-city").append(data).addClass('drawer__menuli-city-loaded');
                    this.event_listener();

                    if (typeof callback === "function")
                        callback();
                }
            );
        }
    },

    event_listener: function() {
        jQuery( "body" ).on( "keyup", ".js-city__select", function(e) {
            let val = $.trim($(this).val());

            if (!CITY.loading) {
                if (val.length > 2) {
                    CITY.loading = true;

                    $.post(
                        '/aj',
                        {
                            term: val,
                            action: 'u',
                            locale: G.locale_id,
                            to: 'lookupcity',
                        },
                        function(data) {
                            CITY.loading = false;
                            CITY.build_list(data);
                        },
                        'json'
                    )
                }
            }
        });
    },

    build_list: function(data) {
        let autocompleter = $('.drawer__citylist-autocompleter');

        autocompleter.empty();

        if (data.length > 0) {
            data = data.slice(0, 10);
            $.each(data, function (i, item) {
                autocompleter.append('<a href="#" class="drawer__cityitem js-drawer__cityitem" data-id="' + item.id + '" data-title="' + item.title + '">' + item.text + '</a>');
            });
        } else
            autocompleter.append('<a href="#" class="drawer__cityitem">' + __('Не знайдено') + '</a>');
    }
}

export const WISHLIST = {
    loaded: false,
    revision: '',
    action: G.manager_logged ? 'slr' : 'users',
    key: 'wishlist',
    revision_key: 'wishlist_revision',
    sku: new Map(),

    load_page: function(context_id) {
        this.load();

        $(".wishlist-goods").empty().addClass('load-animation');

        $.post(
            '/aj',
            {
                action: 'u',
                to: 'wishlist',
                locale: G.locale_id,
                context_id: context_id
            },
            function (data) {
                $(".wishlist-goods").removeClass('load-animation').html(data.html);
                WISHLIST.sku.clear();

                if (data.sku.length > 0)
                    data.sku.forEach((sku) => {
                        if (parseInt(sku))
                            WISHLIST.sku.set(parseInt(sku), sku)
                    });

                WISHLIST.update_anchors();
                $(".container__title small").html(BROWSE.count_str($(".wishlist-goods .loop").length));

                if ($(".wishlist-goods .loop").length)
                    $.each($(".wishlist-goods .loop"), function(i, loop){
                        loop = $(loop).find('.title');

                        GTM.event('push_product_details', {
                            list: 'wishlist',
                            name: loop.data('name'),                      // Name or ID is required.
                            sku: loop.data('sku'),
                            price: loop.data('price'),
                            brand: loop.data('brand'),
                            category: loop.data('category'),
                            variant: loop.data('variant')
                        }, 0, 'wishlist', '');
                    });
            },
            'json'
        );
    },

    load: function(force) {
        if (!this.loaded || force) {
            this.loaded = true;
            WISHLIST.revision = localStorage.getItem(this.revision_key);

            if (WISHLIST.revision==G.wishlist_revision) {
                var list = localStorage.getItem(this.key);
                list = typeof list === "string" ? list.split(',') : [];

                if (list.length)
                    $.each(list, function (i, sku) {
                        if (parseInt(sku))
                            WISHLIST.sku.set(parseInt(sku), sku);
                    });
            } else
                this.synchronize('', '', function(){
                    WISHLIST.update_anchors();
                });
        }
    },

    count: function() {
        this.load();
    },

    clean: function() {
        this.load();
        this.sku.clear();
        this.set_storage();

        if (USER.is_logged() || G.b2bmode || G.manager_logged)
            this.synchronize('', 'removeall');

        this.update_anchors();
    },

    remove: function(sku) {
        this.load();

        sku = parseInt(sku);

        if (sku) {
            if (this.sku.get(sku))
                this.sku.delete(sku);

            this.set_storage();

            if (USER.is_logged() || G.b2bmode || G.manager_logged)
                this.synchronize(sku, 'remove');
            else
                this.update_anchors();
        }
    },

    add: function(sku, btn) {
        this.load();

        sku = parseInt(sku);

        if (sku) {
            let method = 'add';

            if (!this.sku.get(sku)) {
                this.sku.set(sku);

                if (btn)
                    GTM.event('add_to_wishlist', btn, 0, 'wishlist', '');
            } else {
                method = 'remove';
            }

            if (USER.is_logged() || G.b2bmode || G.manager_logged)
                this.synchronize(sku, method);
            else
                this.update_anchors(true);
        }
    },

    set_storage: function() {
        localStorage.setItem(this.key, Array.from(this.sku.keys()).join(','));
    },

    synchronize: function(sku, method, callback) {
        this.load();

        $.post(
            '/aj',
            {
                action: this.action,
                to: 'wishlist',
                locale: G.locale_id,
                wishlist: sku,
                method: method
            },
            function (data) {
                WISHLIST.sku.clear();
                if (data.sku.length > 0)
                    data.sku.forEach((sku) => {
                        if (parseInt(sku))
                            WISHLIST.sku.set(parseInt(sku), sku)
                    });

                WISHLIST.set_storage();
                localStorage.setItem(WISHLIST.revision_key, data.revision);

                WISHLIST.update_anchors();

                if (typeof callback === "function")
                    callback();
            },
            'json'
        );
    },

    update_anchors: function(animation) {
        this.load();
        $(".ri-wishlist").removeClass('ri-wishlist-active').data('target', '.ri__wishlisthover');
        $(".icon-wishlist a span").remove();
        $(".hb__uicon-wishlist span").remove();

        if (this.sku.size) {
            $(".icon-wishlist a").append('<span>' + this.sku.size + '</span>');
            $(".hb__uicon-wishlist").append('<span>' + this.sku.size + '</span>');

            this.sku.forEach((sku) => {
                $(".ri-wishlist[data-sku=" + sku + "]").addClass('ri-wishlist-active').data('target', '.ri__wishlisthover-filled');
            });
        }

        COMPARSION.opacity_ri();
    }
}

export const KE = {
    key: 'ke',
    data: {},
    current_time: parseInt(Date.now().toString().substring(0, 10)),
    session_timeout: 3600,
    maximum_events: 100,
    timer: 0,
    interval: false,
    interval_timeout: 1000,
    fired: [],
    user_data: {
        pages: 0,
        time_on_page: 0
    },
    triggers: [
        /*
        {
            name: 'show_subscribe_tab',
            requirements: [
                {
                    key: 'pages',
                    possible: '>=',
                    value: 3
                },
                {
                    key: 'session_time',
                    possible: '>=',
                    value: 120
                }
            ],
            callback: function() {
                U.open_supportman_subscribe();
                return 'showed';
            }
        },

        {
            name: 'catalog_subscribe',
            requirements: [
                {
                    key: 'pages',
                    possible: '>=',
                    value: 3
                },
                {
                    key: 'maximum_events',
                    possible: '<=',
                    value: 5
                },
                {
                    key: 'catalog_id',
                    possible: '>=',
                    value: 1
                },
                {
                    key: 'last_fired_span',
                    possible: '>=',
                    value: 120
                }
            ],
            callback: function() {
                return FILTER.insertPromoLoop();
            }
        }
         */
    ],
    init: function() {
        if (localStorage.getItem(this.key)) {
            try {
                this.data = JSON.parse(localStorage.getItem(this.key));
                this.data = typeof this.data === "object" ? this.data : {};
            } catch(e) {
                this.data = {};
            }
        }

        this.data.begin = typeof this.data.begin === "undefined" ? 0 : parseInt(this.data.begin);
        this.data.events = typeof this.data.events === "undefined" ? [] : this.data.events;
        this.user_data = typeof this.data.user_data === "undefined" ? {} : this.data.user_data;

        if ((this.data.begin + this.session_timeout) < this.current_time) {
            this.data.begin = this.current_time;
            this.user_data.pages = 0;
        }

        this.data.current = this.current_time;

        // set user data
        this.user_data.pages = this.user_data.pages || 0;
        this.user_data.pages++;

        this.update_fired_events();
        this.sync();
        this.init_interval();
    },
    push_ajax_request: function() {
        this.user_data.pages++;
        this.sync();
    },
    user_data_value: function(key, event_name) {
        let result = null;

        switch(key) {
            case 'time_on_page':
                result = parseInt(Date.now().toString().substring(0, 10)) - this.current_time;
                break;

            case 'catalog_id':
                result = typeof catalog_id === "undefined" ? 0 : catalog_id;
                break;

            case 'maximum_events':
                result = 0;

                if (this.data.events.length > 0)
                    $.each(this.data.events, function(i, item) {
                        if (typeof item === "object" && !(typeof item.counter === "undefined") && !(typeof item.name === "undefined") && item.name==event_name) {
                            result = item.counter;
                        }
                    });

                break;

            case 'session_time':
                result = parseInt(Date.now().toString().substring(0, 10)) - this.data.begin;
                break;

            case 'last_fired_span':
                result = 0;
                let time = parseInt(Date.now().toString().substring(0, 10));

                if (this.data.events.length > 0)
                    $.each(this.data.events, function(i, item) {
                        if (typeof item === "object" && !(typeof item.counter === "undefined") && !(typeof item.name === "undefined") && item.name==event_name) {
                            result = item.time;
                        }
                    });

                result = time - result;

                break;

            default:
                result = this.user_data[key] || null;
        }

        return result;
    },
    update_fired_events: function() {
        this.fired = [];

        if (this.data.events.length)
            $.each(this.data.events, function(i, event){
                KE.fired.push(event);
            });
    },
    sync: function() {
        this.data.user_data = this.user_data;
        localStorage.setItem(this.key, JSON.stringify(this.data));
    },
    init_interval: function() {
        this.interval = setInterval(function() {
            KE.increment();
            KE.do_event();
        }, this.interval_timeout);
    },
    get_timer: function() {
        return this.timer;
    },
    check_requirements: function(requirements, event_name) {
        let result = true;

        if (typeof requirements === "object" && requirements.length)
            $.each(requirements, (i, requirement) => {
                if (result) {
                    let value = this.user_data_value(requirement.key, event_name);
                    requirement.possible = requirement.possible || '';

                    switch(requirement.possible) {
                        case '>=':

                            if (!(parseInt(value) >= parseInt(requirement.value))) {
                                result = false;
                            }

                            break;

                        case '<=':
                            if (!(parseInt(value) <= parseInt(requirement.value))){
                                result = false;
                            }
                            break;

                        case '=':
                            if (!(parseInt(value) == parseInt(requirement.value))) {
                                result = false;
                            }
                            break;

                        default:
                            result = false;
                            break;
                    }
                }
            });

        return result;
    },
    allow_do_event: function(event_name) {
        let counter = 1;
        $.each(this.triggers, function(trigger_key, trigger){
             if (trigger.requirements.length && trigger.name==event_name)
                 $.each(trigger.requirements, function(r, requirement) {
                     if (requirement.key=='maximum_events')
                         counter = requirement.value;
                 });
        });

        let exists_counter = 0;

        if (this.data.events.length > 0)
            $.each(this.data.events, function(i, item) {
                if (typeof item === "object" && !(typeof item.counter === "undefined") && !(typeof item.name === "undefined") && item.name==event_name) {
                    exists_counter = item.counter;
                }
            });

        return counter > exists_counter ? true : false;
    },
    do_event: function() {
        if (this.triggers.length)
            $.each(this.triggers, function(i, trigger) {
                if (
                    trigger &&
                    KE.allow_do_event(trigger.name) &&
                    typeof trigger.requirements === "object" &&
                    KE.check_requirements(trigger.requirements, trigger.name) &&
                    typeof trigger.callback === "function"
                ) {
                    var callback_data = trigger.callback();
                    if (callback_data) {
                        KE.add_event(trigger.name, callback_data);
                    }
                }
            });
    },
    shutdown: function() {
        clearInterval(this.interval);
        this.timer = 0;
    },
    increment: function() {
        this.timer += this.interval_timeout;
    },
    add_event: function(event_name, event_data) {
        let time = parseInt(Date.now().toString().substring(0, 10));
        let counter = 1;

        if (this.data.events.length > 0)
            $.each(this.data.events, function(i, item) {
                if (typeof item === "object" && !(typeof item.counter === "undefined") && !(typeof item.name === "undefined") && item.name==event_name) {
                    counter = item.counter + 1;
                }
            });

        this.data.events.push({
            time: time,
            name: event_name,
            data: event_data,
            counter: counter
        });

        this.update_fired_events();
        this.sync();
    }
}

export function __(text) {
    return G.locale_id && !(typeof TR === "undefined") && U.isset(TR) && U.isset(TR[text]) ? TR[text] : text;
}

export const TOOLTIP = {
    exists: 0,
    remove: function() {
        $("body .tooltip").remove();
        this.exists = 0;
    },
    hide: function() {
        if ($("body .tooltip").length > 0){
            $("body .tooltip").removeClass('show');

            $.each($("body .tooltip"), (i, item) => {
                item = $(item);
                item.trigger('tooltip:off');

                setTimeout(function(){
                    item.remove();
                }, 500);
            });

            $.each($(".open-tooltip, .open-tooltip-closure"), function(i, item) {
                item = $(item);

                if (item.data('toggle') && item.hasClass(item.data('toggle'))) {
                    console.log('remove class', item.data('toggle'));
                    item.removeClass(item.data('toggle'));
                }
            });

            if ($(".tooltip__toggled").length > 0) {
                $.each($(".tooltip__toggled"), function(i, item) {
                    item = $(item);
                    item.removeClass('tooltip__toggled').removeClass(item.data('toggled-class')).data('toggled-class', '');
                });
            }
        }
    },

    confirm: function(btn, title, buttons = []) {
        let html = $('<div></div>');
        html.append('<div class="tooltip__close"></div>');
        html.append(`<div class="tooltip__confirmtitle">${title}</div>`);
        html.append(`<div class="tooltip__confirmbuttons"></div>`);

        if (buttons.length > 0) {
            buttons.map((item) => {
                let el = $(`<button type="button">${item.title}</button>`);
                el.addClass(item.class);
                el.on('click', item.onclick);
                html.find('.tooltip__confirmbuttons').append(el);
            }).join('');
        }

        this.open(btn, {
            target: 'html',
            place: 'top',
            subclass: 'tooltip-confirm',
            html: html
        });
    },

    /**
     *
     * @param btn
     * @param params
     * params:
     *  - target: source data (div, ajax)
     *  - place: top, bottom, left, right
     *  - url: ajax url
     *  - subclass: add class
     */
    open: function(btn, params) {
        if ($("body .tooltip").length > 0){
            TOOLTIP.hide();
        }

        params = typeof params === "object" ? params : {};
        params.fixed = typeof params.fixed === "undefined" ? false : params.fixed;
        params.toggle = typeof params.toggle === "undefined" ? false : params.toggle;

        if (params.toggle) {
            btn.toggleClass(params.toggle);
            btn.addClass('tooltip__toggled').data('toggled-class', params.toggle);
        }

        try {
            if (!(typeof params.target === "undefined")) {

                let place = typeof params.place === "undefined" ? 'top' : params.place;
                let html = $("<div></div>");

                if (btn.hasClass('change-city'))
                    if ($(window).width() >= 1260 && $(window).width() < 1440)
                        place = 'right';

                html
                    .data('target', params.target)
                    .addClass('tooltip')
                    .addClass(params.place)
                    .append('<div><div class="pseudo"></div></div>')
                ;

                if (!(typeof params.subclass === "undefined"))
                    html.addClass(params.subclass);

                if (html.hasClass('tooltip-mobile') && U.isMobile())
                    $(".menubg").addClass('show');

                if (!(typeof params.remove_onscroll === "undefined"))
                    html.addClass('remove-onscroll');

                if (params.fixed)
                    html.addClass('fixed');

                if (params.target=='ajax') {
                    let _params = {};
                    let url = params.url;

                    let regex = /[?&]([^=#]+)=([^&#]*)/g,
                        match;

                    while(match = regex.exec(url))
                        _params[match[1]] = match[2];

                    $.post(
                        params.url,
                        _params,
                        (result) => {
                            html.find('>div').append(result);
                            this.position(html, place, btn, params.fixed);
                        }
                    );
                }
                else {
                    if (params.target=='self') {
                        html.find('>div').append(btn.attr('title'));
                    } else if (params.target=='html') {
                        html.find('>div').append(params.html);
                    } else if (params.target=='black') {
                        html.find('>div').append(`<div class="tooltip__close"></div>${btn.data('title')?`<div class="tooltip__title">${btn.data('title')}</div>`:``}<div class="tooltip__text">${btn.data('text')}</div>`);
                    } else {
                        html.find('>div').append($(params.target).html());
                    }

                    this.position(html, place, btn, params.fixed, params.target=='black' ? 'black' : 'typical');

                    let fadeinout = params.fadeinout ?? false;

                    if (fadeinout) {
                        setTimeout(() => {
                            html.removeClass('show');
                            setTimeout(function(){
                                html.remove();
                            }, 500);
                        }, 3000);
                    }
                }

                return html;
            }
        } catch(e) {}
    },

    position: function(html, place, btn, fixed, block_type){
        html.appendTo('body');

        let top = 0;
        let left = 0;
        let try_counter = 0;
        let maximum_counter = 1;
        let another_direction = '';
        let maximum_right = $(window).width();

        while(try_counter < maximum_counter) {
            switch(place) {

                case 'left':
                    top = btn.offset().top + (btn.outerHeight() / 2) - (html.outerHeight()/2);
                    left = btn.offset().left - html.outerWidth() - 12;
                    another_direction = 'right';
                    break;

                case 'right':
                    top = btn.offset().top + (btn.outerHeight() / 2) - (html.outerHeight()/2);
                    left = btn.offset().left + btn.outerWidth() + 16;
                    another_direction = 'left';
                    break;

                case 'bottom':
                    top = btn.offset().top + btn.outerHeight() + 12;
                    left = btn.offset().left + (btn.outerWidth() / 2) - (html.outerWidth()/2) - 2;
                    another_direction = 'top';
                    break;

                case 'bottomright':
                    top = btn.offset().top + btn.outerHeight() + 12;
                    left = btn.offset().left + btn.outerWidth() - html.outerWidth();
                    another_direction = 'top';
                    break;

                case 'topright':
                    top = btn.offset().top - html.outerHeight() - 12;
                    left = btn.offset().left + btn.outerWidth() - html.outerWidth();
                    another_direction = 'bottomright';
                    break;

                case 'bottomleft':
                    top = btn.offset().top + btn.outerHeight() + 12;
                    left = btn.offset().left + btn.outerWidth() - html.outerWidth();
                    another_direction = 'top';
                    break;

                case 'topleft':
                    top = btn.offset().top - html.outerHeight() - 12;
                    left = btn.offset().left;
                    another_direction = 'bottomright';
                    break;

                case 'top':
                    top = btn.offset().top - html.outerHeight() - 12;
                    left = btn.offset().left + (btn.outerWidth() / 2) - (html.outerWidth() / 2);
                    another_direction = 'bottom';
                    break;

                default: break;
            }

            if (((place=='top' || place=='topright') && top < 0) || (place=='left' && left < 0)) {
                maximum_counter = 2;
                html.removeClass(place).addClass(another_direction);
                place = another_direction;
                continue;
            } else {
                // right left

                if (left < 0 || ((left + html.outerWidth()) > maximum_right)) {
                    if (block_type=='black') {
                        maximum_counter = 2;
                        if (left < 0) {
                            another_direction = `${place}left`;
                        } else {
                            another_direction = `${place}right`;
                        }
                        html.removeClass(place).addClass(another_direction);
                        place = another_direction;
                        continue;
                    } else {
                        if (left < 0) {
                            // торчить зліва
                            html.find('.pseudo').css('left', 'calc(50% - 15px - ' + (left * -1) + 'px');
                            left = 16;
                        }
                        if ((left + html.outerWidth()) > maximum_right) {
                            // toрчить справа
                            let new_left = maximum_right - 16 - html.outerWidth();
                            html.find('.pseudo').css('left', 'calc(50% + 1px + ' + (left - new_left) + 'px');
                            left = new_left;
                        }
                    }

                } else {
                    // fix pseudo position
                    if (place=='topright' || place=='bottomright') {
                        let pseudo_mid_position = html.find('.pseudo').position().left + left + (html.find('.pseudo').width() / 2);
                        let btn_mid_position = btn.offset().left + (btn.outerWidth() / 2);
                        let mid_diff = parseInt(btn_mid_position - pseudo_mid_position);
                        left += mid_diff;
                    }
                }

                if (place == 'right') {
                    html.find('.pseudo').css('top', 'calc(50% - 9px)');
                    html.find('.pseudo').css('left', '-5px');
                }

                if (fixed) {
                    top = parseInt(btn.css('top').replace('px', '')) - html.outerHeight() - 12;
                }

                html.css('top', top);
                html.css('left', left);
            }

            try_counter++;
        }

        html.addClass('show');

        if (!(typeof btn.data('destroy') === "undefined")) {
            html.on("remove", function () {
                try {
                    eval(btn.data('destroy'));
                } catch(e) {};
            });
        }
    }
};

function isset () {
    var a=arguments, l=a.length, i=0;

    if (l===0) {
        throw new Error('Empty isset');
    }

    while (i!==l) {
        if (typeof(a[i])=='undefined' || a[i]===null) {
            return false;
        } else {
            i++;
        }
    }
    return true;
}

export function short_popup(content, className = '') {
    if (!$("body .short-popup").length)
        $("body").append('<div class="short-popup hidden"><a href="#" class="close"></a><div class="wrap"></div></div>');

    $(".short-popup .wrap").html(content);
    $(".short-popup").removeClass('hidden');

    if (className)
        $(".short-popup").addClass(className);

    $(".menubg").addClass('show');
}

function mainSliderSection(){

    if ($(".main-slider").length > 0 && $(".main-slider .slide").length > 1) {

        const initSlider = function(autoplaySpeed = 5000, initialSlide = 0) {

            let slide = $(`.main-slider .slider${initialSlide} a`);
            slide.addClass('loaded');

            console.log('initSlider');

            $('.main-slider').slick({
                arrows: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                autoplay: true,
                autoplaySpeed,
                initialSlide
            }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                U.slickBeautify(slick);
                let next = $(`.main-slider [data-slide=${nextSlide}]`);
                $.each($("img", next), (i, img) => {
                    img = $(img);
                    if (!next.hasClass('slider-loaded')) {
                        img.attr('src', img.data('src'));
                    }
                });

                next.addClass('slider-loaded');
            }).on('afterChange', function(event, slick, currentSlide, nextSlide){
                U.send_impressions();
            });
        };

        initSlider(5000);

        // setTimeout(() => {
        //     $('.main-slider').slick('unslick');
        //     initSlider(5000, 1);
        // }, 2400);
    }

}

function slickLoadLazyLoad(slick) {
    if (slick.$slides.find('img.lazycatalog').length)
        $.each(slick.$slides.find('img.lazycatalog'), function(i, item){
            item = $(item);
            item.attr('src', item.data('lazycatalog')).removeClass('lazycatalog').addClass('loaded');
        });
}

var lastScrollTop = 0;
var lastScrollPosition = 0;
var lastScrollPositionCounter = 0;
var lastScrollDiff = 0;
var lastScrollDirection = '';
var lastScrollSpeedIndex = 0;
var lastScrollBlocked = false;

export const MAINMENU = {
    catalog_menu_loaded: false,
    menu_timeout: false,
    element: false,
    show_submenu: function(element) {
        this.prevent_submenu();

        if (G.portalid==7) {
            return;
        }

        this.element = element;
        this.menu_timeout = setTimeout(function() {
            try {
                element.trigger('click');
            } catch(e) {}
        }, 1000);
    },

    prevent_submenu: function() {
        clearTimeout(this.menu_timeout);
    },

    load_catalog_menu: function(callback)
    {
        if (MAINMENU.catalog_menu_loaded || G.portalid==7) {
            if (typeof callback === "function")
                callback();
        } else {
            let prefix = '';

            switch(G.channel) {
                case 3:
                    prefix = 'b2b-';
                    break;

                case 10:
                    prefix = 'b2c-';
                    break;

                default:
                    break;
            };

            $.get(
                `/inc/${prefix}menu.html`,
                {},
                function (data) {
                    $(".drawer__menuloader").remove();
                    $(".drawer__menuitem-catalog").append(data);
                    MAINMENU.catalog_menu_loaded = true;

                    if (typeof callback === "function")
                        callback();
                }
            );
        }
    },

    open_catalog_submenu: function(btn) {
        if (U.isMobile()) {
            btn = $(">a", btn);
            if (btn.parent().find('.drawer__menuinner').length > 0) {
                var append = $(
                    '<div class="screen">' +
                    '<div class="screen__top">' +
                    '   <a href="javascript: void(null);" class="screen__back"></a>' +
                    '   <div class="screen__title">' + (btn.data('title') ? btn.data('title') : btn.text()) + '</div>' +
                    '   <a href="javascript: void(null);" class="drawer__close"></a>' +
                    '</div>' +
                    '<div class="screen__menu gtm-menu" data-parent="' + btn.text() + '" data-id="menu' + (G.locale_id ? '1' : '') + '1"></div>' +
                    '</div>');

                $(".drawer >.screen").remove();
                $(".drawer .screen-main").addClass('collapsed');

                append.find('.screen__menu').append(btn.parent().find('.drawer__menuinner').html());
                append.appendTo($(".drawer")).addClass('visible');
            } else {
                return true;
            }
        } else {
            btn.toggleClass('drawer__menuli-active');
            $(".drawer__menuli-active").not(btn).removeClass('drawer__menuli-active');
        }
    }
}

export const HEADERSCROLL = {
    scroll_blocked: false,
    scroll_timeout: false,

    blocked: function() {
        return this.scroll_blocked;
    },

    block: function() {
        return;
        clearTimeout(this.scroll_timeout);
        this.scroll_blocked = true;
        this.scroll_timeout = setTimeout(function() {
            HEADERSCROLL.scroll_blocked = false;
        }, 1000);
    }
}

export const JOBS = {
    joblist: [],
    jobcounter: 0,
    history_timeout: false,
    JOB_stash: [],
    action: function() {
        return G.manager_logged || G.worker_logged ? 'slr' : 'u';
    },
    init_JOB: function(url, params, callback, error_callback, destroy_callback, el){

        if (this.joblist.filter(function(x){ return x != ""}).length == 3) {
            if (typeof destroy_callback === "function")
                destroy_callback();
            return;
        }

        this.jobcounter++;
        this.joblist[this.jobcounter] = new JOB(url, params, callback, error_callback, destroy_callback, el);
    }
}

export const JOB = function(url, params, callback, error_callback, destroy_callback, el) {
    this.currentTimeout = 0;
    this.currentTimeoutId = false;

    if (typeof el==="object")
        el.addClass('job-' + JOBS.jobcounter);

    this._url = url;
    this._params = params;
    this._callback = callback;
    this._error = error_callback;
    this._destroy = destroy_callback;

    this.runcounter = 0;
    this.counter = JOBS.jobcounter;
    this.container = $(".job-" + JOBS.jobcounter);
    this.timeout = 1500;
    this.timeoutobj = false;
    var that = this;

    this.beginWork = function() {

        if (el)
            el.addClass('load-animation js-loadanimation');

        $.ajax({
            type: "POST",
            url: that._url,
            data: that._params,
            dataType: "json",
            timeout: 10000, // in milliseconds
            success: (result) => {
                if (typeof result === "object" && !(typeof result.update === "undefined")) {
                    if (result.update > 0) {
                        that.setTimeout(function() {
                            that.beginWork();
                        }, result.update);
                    } else {
                        if (el)
                            el.removeClass('load-animation js-loadanimation');

                        if (result.update==0) {
                            if (typeof el==="object") {
                                el.addClass(`jobid-${result.id}`);
                            }

                            if (typeof that._callback === "function")
                                that._callback(result);
                        } else {
                            if (typeof that._error === "function")
                                that._error(result);
                        }

                        if (typeof that._destroy === "function")
                            that._destroy(result);

                        delete JOBS.joblist[that.counter];
                    }
                } else {
                    if (el)
                        el.removeClass('load-animation js-loadanimation');

                    if (typeof that._error === "function")
                        that._error(result);
                }
            },
            error: function(request, status, err) {
                if (el)
                    el.removeClass('load-animation js-loadanimation');

                if (typeof that._error === "function")
                    that._error(err);
            }
        });
    }

    this.setTimeout = function(func, timeout) {
        clearTimeout(that.currentTimeoutId);
        that.currentTimeout = timeout*1000;
        that.currentTimeoutId = setTimeout(func, that.currentTimeout);
    }

    this.beginWork();
    return this;
};

export function init_GLOBAL_events() {
    $(document).ready(function () {

        jQuery("body").on('click', ".loop__dots", function (e) {
            e.preventDefault();
            let btn = $(this);
            let loop = btn.parents('.loop');

            setTimeout(() => {
                if (btn.hasClass('loop__dots-opened')) {
                    btn.removeClass('loop__dots-opened');
                    $(".loop__extra", loop).removeClass('loop__extra-opened');
                    $(".loop-blured").removeClass('loop-blured');
                } else {
                    btn.addClass('loop__dots-opened');
                    $(".loop__extra", loop).find('.loop__ri').remove();
                    $(".loop__extra >div", loop).prepend(loop.find('.loop__ri').clone());
                    $(".loop__extra", loop).find('.loop__ri').addClass('loop__ri-fixed');
                    $(".loop__extra", loop).addClass('loop__extra-opened');

                    if (loop.index() % 2 == 0)
                        loop.next().addClass('loop-blured');
                    else
                        loop.prev().addClass('loop-blured');
                }
            }, 0)
        });

        jQuery("body").on('load', ".for-impressions img", function (e) {
            var img = $(this);
        });

        jQuery("body").on('submit', ".subscribe form", function (e) {
            e.preventDefault();


        });

        jQuery("body").on("click", ".ri-compare", function (e) {
            e.preventDefault();
            let btn = $(this);
            TOOLTIP.remove();

            if (btn.hasClass('ri-compare-active')) {
                COMPARSION.remove(btn.data('sku'));
            } else {
                let button = btn.parents('.loop').length ? btn.parents('.loop').find('.title') : btn.parents('.product__top').find('.add-to-cart-bold');
                COMPARSION.add(btn.data('sku'), btn.data('context'), button, () => {
                    if (COMPARSION.context_count(btn.data('sku')) > 1)
                        TOOLTIP.open(btn, {
                            target: '.ri__comparehover-filled',
                            place: 'bottom',
                            subclass: 'tooltip-compare'
                        });
                });
            }
        });

        jQuery("body").on("click", ".comparsion__table .slick-dots button", function (e) {
            e.preventDefault();

            let btn = $(this).parent();
            let index = btn.index();
            const btn_length = $(".comparsion__table .slick-dots button").length;

            btn.parent().find('.slick-active').removeClass('slick-active');
            btn.addClass('slick-active');

            if (index == 0) {
                $(".comparsion-scroll.left").removeClass('comparsion-scroll-active');
            } else {
                $(".comparsion-scroll.left").addClass('comparsion-scroll-active');
            }

            let max = index + 3;
            // console.log(btn_length, max);

            if (btn_length > max) {
                $(".comparsion-scroll.right").addClass('comparsion-scroll-active');
            } else {
                $(".comparsion-scroll.right").removeClass('comparsion-scroll-active');
            }

            let width = 0;
            for (let i = 1; i <= index; i++) {
                width += $(".js-comparsion__table .scroll .item:eq(" + (i - 1) + ")").outerWidth();
                console.log(`width: ${$(".js-comparsion__table .scroll .item:eq(" + (i - 1) + ")").outerWidth()}`);
            }

            console.log(index, `scroll width: ${width}`);

            $(".main-container .scroll").animate({scrollLeft: width}, '200', 'swing');
        });

        jQuery("body").on("click", ".comparsion-scroll", function (e) {
            e.preventDefault();

            let btn = $(this);
            // if (btn.hasClass('comparsion-scroll-active')) {
                if (btn.hasClass('left')) {
                    const current = $(".comparsion__table.js-comparsion__table .slick-active").index();
                    $(`.comparsion__table.js-comparsion__table li:eq(${Math.max(0, current - 3)})`).find('button').trigger('click');
                }
                else
                    $(".comparsion__table.js-comparsion__table .slick-active").next().find('button').trigger('click');
            // }
        });

        jQuery("body").on("click", ".faq-item .item-title", function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('opened');
        });

        jQuery("body").on("click", ".blog__page .opened-catalog-menu .mainmenu ul li a", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this).parent();
            $(".menu__toggle").trigger('click');
            $(".open-catalog").trigger('click', function () {
                $(".drawer .screen.visible .menu >ul >li:eq(" + btn.index() + ") a").trigger('click');
            });

        });

        U.init_full_size_gallery();

        if ($(".homepage-top").length)
            $(".homepage-top .timer").countdown($(".homepage-top .timer").data('date'), function (event) {
                $(this).html(event.strftime('%H : %M : %S'));
            });

        // opened box
        jQuery("body").on("click touchend", ".stickers .opened-box", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var btn = $(this);
            btn.append("<div>Знижка 100 грн</div>");
        });

        // preorder
        jQuery("body").on("click", "a.preorder, a.preorder-esim, span.preorder, span.preorder-esim, .buy-preorder, .loop__buy-preorder, .b2blist__preorder", function (e) {
            e.preventDefault();
            var btn = $(this);

            if (btn.hasClass('preorder-esim'))
                DRAWER.init('workdrawer-make-preorder workdrawer-full', {
                    action: 'popup',
                    to: 'preorderesim',
                    locale: G.locale_id,
                    sku: btn.data('sku'),
                }, function () {
                    U.mask_inputs()
                });
            else
                DRAWER.init('workdrawer-preorder workdrawer-full', {
                    action: 'popup',
                    to: 'preorder',
                    locale: G.locale_id,
                    sku: btn.data('sku'),
                }, function () {
                    U.mask_inputs();
                    $(".form-preorder [name=phone]").trigger('keyup');
                });
        });

        // leadform
        jQuery("body").on("click", ".js-popup__leadform", function (e) {
            e.preventDefault();
            const btn = $(this);

            CARD.load_GA_data();

            DRAWER.init('workdrawer-leadform workdrawer-full', {
                action: 'popup',
                to: 'leadform',
                locale: G.locale_id,
                formnameid: btn.data('formnameid'),
                formtitle: btn.data('formtitle')
            }, function () {
                U.mask_inputs();
                $(".js-leadform input").trigger('keyup');
                GTM.fireStatistick('statistick', 'click', 'Відкриття lead форми', btn.data('formnameid'));
            });
        });

        jQuery("body").on("submit", ".js-leadform", function (e) {
            e.preventDefault();
            const form = $(this);

            if (!form.find('[type=submit]').hasClass('active')) {
                return;
            }

            const form_id = form.find('[name=form_id]').val();

            $.post(
                '/aj',
                {
                    action: 'popup',
                    to: 'leadformsend',
                    locale: G.locale_id,
                    name: form.find('[name=name]').val(),
                    phone: form.find('[name=phone]').val(),
                    comment: form.find('[name=comment]').val(),
                    form_id: form_id,
                    form_name: form.find('[name=form_name]').val(),
                    google_session: CARD.GA_data.session_id,
                    google_client_id: CARD.GA_data.client_id
                },
                function (data) {
                    GTM.event('generate_lead', 10, data.form_id, 'lead_form');

                    if (U.isMobile()) {
                        DRAWER.init('workdrawer-writebug_thx', {action: 'popup', to: 'leadformthx'});
                    } else {
                        DRAWER.destroy();
                        short_popup(data.html);
                    }
                },
                'json'
            );
        });

        jQuery("body").on("keyup", ".js-leadform input, .js-leadform textarea", function (e) {
            const form = $(this).parents('.js-leadform');
            const phone = form.find('[name=phone]').val();

            if ($.trim(form.find('[name=name]').val()) == '' || !(phone.replace(/\D/g, '').length == 10))
                form.find('[type=submit]').removeClass('active');
            else
                form.find('[type=submit]').addClass('active');
        });

        // check availability
        jQuery("body").on("click", ".checkav, .b2blist__checkav, .open-checkav", function (e) {
            e.preventDefault();
            let btn = $(this);

            DRAWER.init('workdrawer-check-availability workdrawer-full', {
                action: 'popup',
                to: 'checkav',
                locale: G.locale_id,
                sku: btn.data('sku'),
            }, function () {
                U.mask_inputs()
            });
        });

        // short-popup
        jQuery("body").on("click touchend", ".short-popup .close, .js-closeshortpopup", function (e) {
            e.preventDefault();
            $(".menubg").removeClass('show');
            $(".short-popup").remove();
        });

        $(".stickers >span").click(function (e) {
            e.preventDefault();
        });

        // Cart
        jQuery("body").on("click", ".header__cart, .js-header__cart", function (e) {
            e.preventDefault();
            CARD.toggle();
        });

        jQuery("body").on("click", ".add-to-cart:not(.preorder-esim), .add-in-order, .buy:not(.buy-preorder):not(.buy-productlimited), .loop__buy:not(.loop__buy-preorder):not(.loop__buy-makepc), .b2blist__buy-b2blist", function (e) {
            e.preventDefault();
            let btn = $(this);
            let count = 1;

            if (btn.hasClass('buy-bundle')) {
                btn.addClass('buy-bundle-loading');

                CARD.add_bundle_to_cart(btn).finally(() => {
                    btn.removeClass('buy-bundle-loading');
                });
            } else {
                if (btn.hasClass('loop__buy-looplimited'))
                    if (!G.city_id) {
                        document.location.assign(`${btn.parents('.loop').find('.loop__title').attr('href')}#openmap`);
                        return;
                    }

                if (btn.parent().hasClass('add-to-card-with-count'))
                    count = btn.parent().find('input').val();

                if (btn.hasClass('buy')) {
                    let services = [];

                    if ($(".product__service input:checked").length > 0)
                        $.each($(".product__service input:checked"), function (i, item) {
                            services.push($(item).val());
                        });

                    if (services.length > 0)
                        return CARD.add_with_services(btn.data('sku'), services, 1);
                }

                CARD.add(btn.data('sku'), 1, btn.data('list'), btn.data(), count, function () {
                    btn.addClass('added').append('<div class="added"></div>');

                    btn.parents('.cart__item').fadeOut(function () {
                        $(this).remove();
                    });
                });
            }

            return false;
        });

        // Открываем форму регистрации
        jQuery("body").on('click', '.header__login, .drawer .login, .openloginform, .js-user__openlogin', function (e) {
            e.preventDefault();
            let btn = $(this);

            DRAWER.init('workdrawer-auth workdrawer-full', {
                action: 'u',
                to: 'login',
                locale: G.locale_id,
                page: document.location.pathname,
                source: btn.data('source')
            }, function () {
                U.mask_inputs();

                let date = new Date();
                date.setTime(date.getTime() + (180 * 1000));

                Cookies.set("merge_after_login", 1, {
                    path: '/',
                    expires: date
                });

                setTimeout(function () {
                    $(".workdrawer .auth-form [name=login]").get(0).focus();
                }, 200);

                if (!USER.cookie_allowed())
                    USER.show_cookie_popup();

                if (jQuery.isFunction(USER.callback)) {
                    USER.callback();
                    USER.callback = false;
                }
            });
        });

        jQuery("body").on("click", ".logout", function (e) {
            e.preventDefault();

            if (G.channel == 2 || G.channel == 4) {
                document.location.assign('/slr/logout');
            }

            try {
                USER.logout();
            } catch (e) {
            }
        });

        // nps
        if (command == 'nps_hash')
            $.post('/aj', 'action=n&to=update&hash=' + hash_id, function (data) {
            }, 'json');

        $('body').on('click', ".nps-buttons:not(.for-wizard) >button, .nps-buttons-stars:not(.for-wizard) >button", function (e) {
            e.preventDefault();
            const btn = $(this);
            const val = parseInt(btn.data('val'));
            $.post('/aj', {
                action: 'n',
                to: 'vote',
                hash: hash_id,
                val
            }, function (data) {
                $(".js-nps-buttons").addClass('hidden');

                if (val > 3) {
                    $(".js-nps-success").removeClass('hidden');
                } else {
                    $(".js-nps-additional_answerc").removeClass('hidden');
                }

            }, 'json');
        });

        $('body').on('click', ".js-nps-additional_answer", function (e) {
            e.preventDefault();
            const btn = $(this);
            $.post('/aj', {
                action: 'n',
                to: 'additionalanswer',
                text: $(".js-nps-additional_answerfield").val(),
                hash: hash_id,
            }, function (data) {
                $(".text__right").addClass('hidden');
                $(".nps-success").removeClass('hidden');
                $(".nps-additional_answer").addClass('hidden');
            }, 'json');
        });

        $('body').on('click', ".nps-wizard-question button", function (e) {
            e.preventDefault();
            var btn = $(this);
            var container = btn.parents('.nps-wizard-question');

            container.find('input').val(btn.data('val'));
            container.removeClass('active').addClass('hidden');

            var key = parseInt(container.data('key'));

            if (key == $(".nps-wizard .nps-wizard-question").length) {
                $(".nps-wizard").addClass('hidden');
                $(".nps-success").removeClass('hidden');

                var votes = [];

                $.each($('.nps-wizard-question'), function (i, item) {
                    item = $(item);
                    votes.push(item.find('input').val());
                });

                $.post('/aj', {
                    action: 'n',
                    to: 'vote',
                    hash: hash_id,
                    votes: votes
                }, function (data) {
                    $(".blog__page .text__content >*:not(.nps-success)").addClass('hidden');
                    $(".nps-success").removeClass('hidden');
                }, 'json');
            } else {
                container.next().addClass('active').removeClass('hidden');
            }
        });

        // GTM
        GTM.event('impressions_home');
        
        // view promotion on page
        jQuery("body").on("click", ".for-promogtm, .for-promogtmimp, .js-gtm__promo", function (e) {
            let link = $(this);
            GTM4N.event([
                'select_promotion',
                link.data()
            ]);
            return true;
        });

        if (Cookies.get("auth_action")) {
            switch (Cookies.get("auth_action")) {
                case 'checkout':
                    CARD.open_checkout();
                    break;

                default:
                    break;
            }

            Cookies.remove('auth_action');
        }

        jQuery("body").on("click", ".promo_tooltip a.more", function (e) {
            e.preventDefault();
            e.stopPropagation();
            document.location.assign($(this).attr('href'));
            return false;
        });

        jQuery("body").on("click", ".for-impressions, .loop__title, .hb__looptitle", function (e) {
            // e.preventDefault();
            let target = $(e.target);

            if (target.hasClass('fa') || target.hasClass('slick-next') || target.hasClass('slick-prev'))
                return;

            let link = $(this);

            if (link.hasClass('hb__looptitle')) {
                link = link.parents('.hb__loop').find('.for-impressions');
            }

            let list = link.data('list');
            let position = parseInt(link.data('position'));
            GTM.event('product_click', link, position, list, link.attr('href'));
        });

        jQuery("body").on("click", ".icon-lang a, .language a, .header__langswitch a, .language__choiseitem, .drawer__menuli-language >a", function (e) {

            let btn = $(this);
            let date = new Date();
            date.setTime(date.getTime() + (300 * 300 * 180 * 1000));

            let source = '';

            if (btn.hasClass('header__langswitcha'))
                source = 'right';

            if (btn.hasClass('header__langswitcha-footer'))
                source = 'footer';

            if (btn.hasClass('language__choiseitem'))
                source = 'dropdown';

            if (btn.parent().hasClass('drawer__menuli-language'))
                source = 'drawer';

            Cookies.set("switch_language", btn.data('direction'), {
                path: '/',
                expires: date
            });

            GTM.event('switch_language', btn.data('direction'), source);
            return true;
        });

        jQuery("body").on("click", ".header__city, .js-header__city", function (e) {
            e.preventDefault();

            if (U.isMobile()) {
                $(".menu__toggle").trigger('click');
                $(".drawer__menuli-city > a").trigger('click');
            } else {
                U.bodyscroll(false);
                $(".menubg").addClass('show');

                CITY.load_popup(function () {
                    $(".drawer__menuli-city > a").trigger('click');
                    $(".drawer").addClass('drawer-opencity');
                });
            }

            return true;
        });

        jQuery("body").on("click", ".js-drawer__cityitem", function (e) {
            e.preventDefault();
            let btn = $(this);
            CITY.set_city(btn.data('id'), btn.data('title'));
            U.close_all();
            return true;
        });

        jQuery("body").on("click", ".gtm-menu a", function (e) {

            var parent_text = [];
            var btn = $(this);
            var container = btn.parents('.gtm-menu');

            if (btn.parents('li').length)
                $.each(btn.parents('li'), function (i, item) {
                    item = $(item);
                    if (item.parents('.gtm-menu').length > 0)
                        if (item.find('>a').length > 0)
                            parent_text.push(item.find('>a').text())
                });

            parent_text = (parent_text.length > 1 ? parent_text[parent_text.length - 1] : '');

            if (U.isMobile() && parent_text == '')
                if (container.data('parent'))
                    parent_text = container.data('parent');

            GTM.event('menu', (container ? container.data('id') : '!parent' + btn.text()), btn.text(), parent_text);

            return true;
        });

        if (typeof RM === "object") {
            GTM.remarketing('origin_page_view', RM);
        }

        // Text
        if ($(".collapsible-item-title-link").length) {
            $(".collapsible-item-title-link").click(function (e) {
                e.preventDefault();
                var btn = $(this);
                btn.parent().parent().parent().find('.collapse').toggleClass('in');
                if (btn.find('i').hasClass('fa-caret-down'))
                    btn.find('i').removeClass('fa-caret-down').addClass('fa-caret-up');
                else
                    btn.find('i').removeClass('fa-caret-up').addClass('fa-caret-down');
            });

            $.each($(".collapsible-item-title-link"), function (i, index) {
                var index = $(this);

                index.html(index.html() + ' <i class="fa fa-caret-down"></i>');
            });
        }

        $.each($(".text-formatted p img:not(.custom), .text-formatted div img:not(.custom), .text__content p img:not(.custom), .text__content div img:not(.custom)"), function (index, img) {
            img = $(img);

            if (!(img.css('float') == 'left' || img.css('float') == 'right'))
                img.parent().addClass('clearfix').css('text-align', 'center');
        });

        // write bug
        jQuery("body").on("keyup", ".form-writebug input, .form-writebug textarea", function (e) {
            var form = $(this).parents('.form-writebug');

            if ($.trim(form.find('[name=name]').val()) == '' || $.trim(form.find('[name=email]').val()) == '' || $.trim(form.find('[name=text]').val()) == '')
                form.find('[type=submit]').removeClass('active');
            else
                form.find('[type=submit]').addClass('active');
        });

        jQuery("body").on('submit', '.form-writebug', function (e) {
            e.preventDefault();
            let form = $(this);
            let btn = $(this).find('[type=submit]');

            G.recaptcha_checked ??= false;

            if (btn.hasClass('active')) {
                if (G.recaptcha_checked || G.channel!=1) {
                    $.post(
                        '/aj',
                        'action=popup&to=writebugsend&url=' + encodeURIComponent(document.location.href) + '&locale=' + G.locale_id + '&' + form.serialize(),
                        function (data) {
                            if (data.success) {
                                form.find('.alert').addClass('hidden');
                                if (U.isMobile()) {
                                    DRAWER.init('workdrawer-writebug_thx', {action: 'popup', to: 'writebugthx'});
                                } else {
                                    DRAWER.destroy();
                                    short_popup(data.html);
                                }
                            } else {
                                form.find('.alert').html(data.errors.join(', ')).removeClass('hidden');
                            }
                        },
                        'json'
                    );
                } else {
                    form.find('.alert').html('Підтвердіть, що ви не робот').removeClass('hidden');
                    return false;
                }
            }

            return false;
        });

        jQuery("body").on('click', '.write-bug-btn', function (e) {
            e.preventDefault();
            DRAWER.init('workdrawer-write-bug workdrawer-full', {
                action: 'popup',
                to: 'writebug',
                locale: G.locale_id
            }, function () {
                U.mask_inputs()
            });
            return false;
        });

        $('body').keydown(function (e) {
            if (e.ctrlKey && e.keyCode == 13) {
                DRAWER.init('workdrawer-write-bug workdrawer-full', {
                    action: 'popup',
                    to: 'writebug',
                    locale: G.locale_id
                }, function () {
                    U.mask_inputs()
                });
            }
        });

        // Write main
        $(".write-main-btn").click(function (e) {
            e.preventDefault();
            DRAWER.init('workdrawer-write-main workdrawer-full', {
                action: 'popup',
                to: 'writemain',
                locale: G.locale_id
            }, function () {
                U.mask_inputs()
            });
        });

        jQuery("body").on('click', ".tooltip .close", function (e) {
            e.preventDefault();
            $("body .tooltip").remove();
        });

        jQuery("body").on('click', ".open-subscribe-chat", function (e) {
            e.preventDefault();
            let to = $(this).data('to');
            $("body .tooltip").remove();

            DRAWER.init('workdrawer-subscribe workdrawer-full', {
                action: 'popup',
                to: 'subscribe',
                locale: G.locale_id
            }, function () {
                U.mask_inputs();

                GTM.event('subscribe_tab', to);

                $(".btn-subscribe-chat, .btn-subscribe-chat2, .form-subscribe [type=submit]").data('to', to);

                $(".workdrawer-subscribe .content").append('<div class="subscribe-footer"></div>');
                setInterval(function () {
                    $(".subscribe-footer").addClass('animated');
                }, 700);
                setInterval(function () {
                    $(".workdrawer-subscribe .content").addClass('animated');
                }, 500);
                //subscribe animation
            });
        });

        jQuery("body").on('click', ".btn-subscribe-chat, .btn-subscribe-chat2", function (e) {
            e.preventDefault();
            let btn = $(this);
            $("body .tooltip").remove();

            const to = btn.data('to');

            switch(to) {
                case 'blackfriday':
                    GTM.fireStatistick('statistick', 'click', 'BF відкриття форми', btn.text());
                    break;

                default:
                    break;
            }

            DRAWER.init('workdrawer-subscribe workdrawer-full', {
                action: 'popup',
                to: 'subscribe',
                locale: G.locale_id
            }, function () {
                U.mask_inputs();

                GTM.event('subscribe_open', btn.data('to'));

                $(".workdrawer-subscribe .content").find('[name=formType]').val('BlackFriday');
                $(".workdrawer-subscribe .content").append('<div class="subscribe-footer"></div>');

                setInterval(function () {
                    $(".subscribe-footer").addClass('animated');
                }, 700);

                setInterval(function () {
                    $(".workdrawer-subscribe .content").addClass('animated');
                }, 500);

                //subscribe animation
            });
        });

        jQuery("body").on("click", ".workdrawer-subscribe .services-list.allow small", function (e) {
            e.preventDefault();

            var btn = $(this);

            if (btn.hasClass('active')) {
                btn.removeClass('active');
                btn.parent().find('input').val(0);
            } else {
                btn.addClass('active');
                btn.parent().find('input').val(1);
            }

            var form = $(this).parents('.form-subscribe');

            if (!($.trim(form.find('[name=name]').val()) == '') && U.validate_email(form.find('[name=email]').val()) && form.find('[name=allow]').val() == 1) {
                form.find('.alert').addClass('hidden');
                form.find('[type=submit]').addClass('active');
            } else {
                form.find('[type=submit]').removeClass('active');
            }
        });

        jQuery("body").on("keyup", ".form-writemain input, .form-writemain textarea", function (e) {
            const form = $(this).parents('.form-writemain');
            const phone = form.find('[name=phone]').val();

            if ($.trim(form.find('[name=name]').val()) == '' || !(phone.replace(/\D/g, '').length == 10) || $.trim(form.find('[name=text]').val()) == '')
                form.find('[type=submit]').removeClass('active');
            else
                form.find('[type=submit]').addClass('active');
        });

        jQuery("body").on('submit', '.form-writemain', function (e) {
            e.preventDefault();
            let form = $(this);
            let btn = $(this).find('[type=submit]');
            let phone = $(this).find('[name=phone]').val();
            let response = false;

            if (G.channel == 3) {
                response = true;
            } else {
                response = grecaptcha.getResponse();
            }

            if (!response || !btn.hasClass('active') || !(phone.replace(/\D/g, '').length == 10))
                return;

            $.post(
                '/aj',
                {
                    action: 'popup',
                    to: 'writemainsend',
                    locale: G.locale_id,
                    page: document.location.href,
                    name: form.find('[name=name]').val(),
                    phone: form.find('[name=phone]').val(),
                    email: form.find('[name=email]').val(),
                    text: form.find('[name=text]').val(),
                    gresponse: response,
                },
                function (data) {
                    if (data.success) {
                        if (U.isMobile()) {
                            DRAWER.init('workdrawer-writemain_thx', {action: 'popup', to: 'writemainthx'});
                        } else {
                            DRAWER.destroy();
                            short_popup(data.html);
                        }
                    } else {

                    }
                },
                'json'
            );

            return false;
        });

        jQuery("body").on("keyup change", ".form-subscribe input, .form-subscribe textarea", function (e) {
            var form = $(this).parents('.form-subscribe');

            if (!($.trim(form.find('[name=name]').val()) == '') && U.validate_email(form.find('[name=email]').val()) && form.find('[name=allow]').val() == 1) {
                form.find('.alert').addClass('hidden');
                form.find('[type=submit]').addClass('active');
            } else {
                form.find('[type=submit]').removeClass('active');
            }
        });

        jQuery("body").on('submit', '.form-subscribe', function (e) {
            e.preventDefault();
            var form = $(this);

            var errors = 0;
            var name = form.find('[name=name]');
            var email = form.find('[name=email]');
            var allow = form.find('[name=allow]');
            var phone = form.find('[name=phone]');
            var btn = $(this).find('[type=submit]');

            if (form.find('[type=submit]').hasClass('loading'))
                return;

            // check name
            let _name = name.val().split(' ');
            let name_error = false;

            if (_name.length > 1) {
                if (_name[0].length < 2 || _name[1].length < 2 || _name[0].length==_name[1].length) {
                    name_error = true;
                }
            } else {
                name_error = true;
            }

            if (name_error) {
                name.addClass('error');
                errors++;
            }

            if ($.trim(email.val()) == '' || !U.validate_email(email.val())) {
                email.addClass('error');
                errors++;
            } else {
                email.removeClass('error');
            }

            if (allow.val() == '1') {
                email.removeClass('error');
            } else {
                allow.addClass('error');
                errors++;
            }

            // phone
            let digits = phone.val().replace(/[^0-9.]/g, "");
            if (!(digits.length == 10 && USER.codeAllowed(digits))) {
                phone.addClass('error');
                errors++;
            }

            if (errors == 0) {
                GTM.fireStatistick('statistick', 'click', 'BF відправка форми', btn.text());

                form.find('[type=submit]').addClass('loading');
                form.find('.alert').addClass('hidden');

                $.post(
                    '/aj',
                    {
                        action: 'popup',
                        to: 'subscribesend',
                        locale: G.locale_id,
                        page: document.location.href,
                        name: form.find('[name=name]').val(),
                        phone: form.find('[name=phone]').val(),
                        email: form.find('[name=email]').val(),
                        formType: form.find('[name=formType]').val(),
                    },
                    function (data) {

                        if (data.success) {
                            GTM.event('subscribe_send', form.find('[type=submit]').data('to'));

                            if (U.isMobile()) {
                                DRAWER.init('workdrawer-subscribe_thx', {action: 'popup', to: 'subscribethx'});
                            } else {
                                DRAWER.destroy();
                                short_popup(data.html);
                            }
                        } else {
                            form.find('.alert').removeClass('hidden');
                        }
                    },
                    'json'
                );
            } else {
                form.find('.alert').removeClass('hidden');
                return;
            }

            return false;
        });

        // Global
        $("body").on('click touchend', '*', function (e) {
            let target = $(e.target);

            if (!(target.hasClass('ri-wishlist') || target.hasClass('ri-compare') || target.hasClass('promo__tagnav'))) {

                if (!target.hasClass('loop__dots') && target.parents('.loop__extra-opened').length == 0)
                    if ($(".loop__dots-opened").length > 0) {
                        $(".loop__dots-opened").removeClass('loop__dots-opened');
                        $(".loop__extra-opened").removeClass('loop__extra-opened');
                        $(".loop-blured").removeClass('loop-blured');
                    }

                if ($("body .tooltip").length > 0) {
                    if (!target.hasClass('open-tooltip') && target.parents('.open-tooltip').length==0) {
                        if (!(target.hasClass('tooltip') || target.parents('.tooltip').length > 0)) {
                            TOOLTIP.hide();
                        }
                    }
                }

                if ($(".sorting-toggle.active").length && !target.parents('.sorting-toggle').length)
                    $(".sorting-toggle").removeClass('active');

                if (!target.hasClass('opened-box') && $(".opened-box >div").length)
                    $(".opened-box >div").remove();

                $(".sticker2.onStock span").remove();
            }

            return true;
        });

        jQuery("body").on("click", ".nourl", function (e) {
            e.preventDefault();
            return false;
        });

        $("body").on('click', '.seo-link', function (e) {
            e.preventDefault();
            var body = $("html, body");
            body.stop().animate({scrollTop: $(".seo").offset().top - 100}, '100', 'swing');

            $(".toggle-seo").trigger('click');
        });

        if (navigator.userAgent.indexOf('Mac') != -1 && navigator.userAgent.indexOf('Chrome') == -1 && navigator.userAgent.indexOf('Firefox') == -1)
            $('body').addClass('fuckedSafari');

        if ($(".touchpanel-setting").length && ((window.innerWidth > 0) ? window.innerWidth : screen.width) == 1080)
            $(".touchpanel-setting").removeClass('hidden');

        mainSliderSection();
        U.slickCatalogPromo();

        $(".toggle-seo").click(function (e) {
            e.preventDefault();
            $(this).remove();
            $(".seo article").removeClass('short').css('line-height', '1.32').css('height', 'auto');
        });

        //tablet scale
        // if(window.screen.width >=768 && window.screen.width < 1280)
        //     $('meta[name=viewport]').attr('content', 'initial-scale=1.0, maximum-scale=1.0, user-scalable=0');

        if ($(window).width() > U.mobileWidth() && $(window).width() < 1360) {
            $('meta[name=viewport]').attr('content', 'user-scalable=0, width=1359');
        } else {
            $('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1');
        }

        window.addEventListener('orientationchange', () => requestAnimationFrame(U.showOrientationChangeAlert), false);
        G.saved_menu = '';

        //search input
        $(".searchform").submit(function (e) {
            let form = $(this);
            let input = form.find('[type=text]');

            if ($.trim(input.val()) == '') {
                e.preventDefault();
                return false;
            }

            SEARCH.push_history(input.val());
            form.append('<input type="hidden" name="t" value="' + SEARCH.encryptStringWithXORtoHex(G.search_token.t, SEARCH.key) + '" />');
        });

        $("body").on('click touchend', '.searchform__close', function (e) {
            e.preventDefault();
            e.stopPropagation();
            SEARCH.clean_form();
        });

        $("body").on('click', '.js-autocompleter__more', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);

            btn.parent().find('.autocompleter__a').removeClass('hidden');
            btn.remove();
        });

        $('.searchform [type=text]').focus(function(e){
            if (!$('.searchform').hasClass('searchform-focused')) {
                $('.searchform').addClass('searchform-focused');
                SEARCH.ping_search($(this));

                if (!$(".main-contain").hasClass('blur')) {
                    $(".main-contain").addClass('blur');
                    $(".menubg-contain").addClass('show');
                    $(".hints").addClass('show');
                } else {
                    $(".hints").removeClass('show');
                }
            }
        });

        $('.search__arrow').click(function (e) {
            e.preventDefault();
            $('input').blur();
            $(".menubg").trigger('click');
        })

        $('.searchform [type=text]').keyup(function (e) {
            e.preventDefault();
            let input = $(this);

            if (e.keyCode == 38 || e.keyCode == 40) {
                e.preventDefault();

                if ($('.autocompleter__a').length > 0) {

                    if (e.keyCode == 40) {
                        SEARCH.searchautocomplete_index = SEARCH.searchautocomplete_index >= 0 ? SEARCH.searchautocomplete_index + 1 : 0; // down
                        SEARCH.searchautocomplete_index = SEARCH.searchautocomplete_index >= $('.autocompleter__a').length ? $('.autocompleter__a').length - 1 : SEARCH.searchautocomplete_index;
                    } else {
                        SEARCH.searchautocomplete_index = SEARCH.searchautocomplete_index > 0 ? SEARCH.searchautocomplete_index - 1 : 0; // up
                    }
                    input.val('');
                    input.focus().val($(".autocompleter__a:eq(" + SEARCH.searchautocomplete_index + ")").data('q'));
                    $(".autocompleter__a").removeClass('active');
                    $(".autocompleter__a:eq(" + SEARCH.searchautocomplete_index + ")").addClass('active');
                }
                return false;
            } else {
                SEARCH.ping_search(input);
            }

            if ($.trim(input.val())) {
                input.addClass('filled');
            } else {
                input.removeClass('filled');
            }

            if (!$(".menubg-contain").hasClass('show')) {
                $(".main-contain").addClass('blur');
                $(".menubg-contain").addClass('show');
            }
        });

        jQuery("body").on("click", ".js-autocompleter__a", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let a = $(this);

            if (a.hasClass('autocompleter__a-unsearch'))
                return;

            $(".searchform [name=q]").focus().val(a.data('q') + ' ');
            $(".searchform [name=qq]").val(a.data('q') + ' ');
            $(".searchform").trigger('submit');
            return false;
        });

        jQuery("body").on("click", ".js-autocompleter__a span.arrow", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let a = $(this).parent();
            $(".searchform [name=q]").focus().val(a.data('q') + ' ');
            $(".searchform [name=qq]").val(a.data('q') + ' ');
            return false;
        });

        jQuery("body").on("mouseover", ".loop:not(.loop-list)", function (e) {
            e.stopPropagation();
            e.preventDefault();
            let loop = $(this);

            if (!loop.hasClass('loop-fixedheight'))
                loop.css('height', loop.height() + 'px').addClass('loop-fixedheight');

            return;
        });

        U.blogGalleries();

        if (document.location.pathname == '/slr/login' && $(".manager-login [name=slrlogin]").length)
            $(".manager-login [name=slrlogin]").get(0).focus();

        jQuery("body").on('submit', '.manager-login', function (e) {
            const form = $(this);
            if ($.trim(form.find('[name=slrlogin]').val())!='' && $.trim(form.find('[name=slrpassword]').val())!='') {
                return true;
            } else {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        });

        if (U.isInView($(".container-lastseen .viewedlist")))
            BROWSE.sliderBrowse();

        document.addEventListener('scroll', function (e) {

            // impressions
            U.send_impressions();

            if ($("body .tooltip.remove-onscroll.show").length) {
                $("body .tooltip.remove-onscroll").removeClass('show');
                setTimeout(function () {
                    $("body .remove-onscroll").remove();
                }, 500);
            }

            SEARCH.fix_autocomplete_position();

            if (U.isMobile()) {
                U.replace_header();
                SEARCH.fix_autocomplete_position();

                if ($(".homepage-slider-mobile:not(.slick-initialized)").length > 0 && U.isInView($(".homepage-slider-mobile:not(.slick-initialized)")))
                    $.each($(".homepage-slider-mobile:not(.slick-initialized)"), function (i, item) {
                        item = $(item);

                        $.each(item.find('img'), function (_i, img) {
                            img = $(img);
                            img.attr('src', img.data('src')).removeClass('lazycatalog').addClass('loaded');
                        });

                        setTimeout(function () {
                            item.slick({
                                arrows: true,
                                infinite: true,
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                nextArrow: false,
                                prevArrow: false,
                                dots: true
                            });
                            item.trigger('resize');
                        }, 0)
                    });
            } else {
                if ($(window).scrollTop() > 150) {
                    $(".product__sticky").addClass('product__sticky-fakeborder');
                } else {
                    $(".product__sticky").removeClass('product__sticky-fakeborder');
                }

                if ($(window).scrollTop() > 600) {
                    $(".product__priceinner-top").addClass('product__priceinner-top-visible');
                    $(".breadcrumbs__li-last").addClass('breadcrumbs__li-last-visible');
                } else {
                    $(".product__priceinner-top").removeClass('product__priceinner-top-visible');
                    $(".breadcrumbs__li-last").removeClass('breadcrumbs__li-last-visible');
                }

                if ($(window).scrollTop() > 100)
                    $(".go-top").addClass('show');
                else
                    $(".go-top").removeClass('show');

                if ($(".product__left .tabs").length) {
                    if ($(window).scrollTop() > 110)
                        $(".product__left, .product__left .tabs").addClass('fixed');
                    else
                        $(".product__left, .product__left .tabs").removeClass('fixed');
                }

                if ($(window).scrollTop() <= 60)
                    $("section.mainmenu").removeClass('fixed');
                else
                    $("section.mainmenu").addClass('fixed');

                // homepage sliders
                if ($(".homepage-slider:not(.slick-initialized)").length && U.isInView($(".homepage-slider:not(.slick-initialized)")))
                    $.each($(".homepage-slider:not(.slick-initialized)"), function (i, item) {
                        item = $(item);

                        $.each(item.find('img'), function (_i, img) {
                            img = $(img);
                            img.attr('src', img.data('lazycatalog')).removeClass('lazycatalog').addClass('loaded');
                        });

                        setTimeout(function () {
                            item.slick({
                                arrows: true,
                                infinite: true,
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                nextArrow: '<button type="button" class="next"></button>',
                                prevArrow: '<button type="button" class="prev"></button>',
                                dots: false,
                                responsive: [
                                    {
                                        breakpoint: 1260,
                                        settings: {
                                            slidesToShow: 3,
                                            slidesToScroll: 1
                                        }
                                    }, {
                                        breakpoint: 769,
                                        settings: "unslick"
                                    }
                                ]
                            });
                            item.trigger('resize');
                        }, 0)
                    });
            }

            if (U.isInView($(".viewedlist")))
                BROWSE.sliderBrowse();

            if ($('.product__similarcontainer').length && U.isInView($('.product__similarcontainer')))
                $.each($('.product__similarcontainer img'), function (e, item) {
                    item = $(item);

                    if (!item.hasClass('loaded'))
                        item.attr('src', item.data('lazy')).addClass('loaded');
                });

        }, {passive: true});

        $(document).keyup(function (e) {
            if (e.keyCode == 27) {
                U.close_all();
            }
        });

        U.send_impressions();

        $('input').keyup(function (e) {
            if (e.keyCode == 27) {
                e.preventDefault();
                $(this).blur();
            }
        });

        jQuery("body").on("click", ".menu__toggle", function (e) {
            e.preventDefault();

            U.bodyscroll(false);

            if ($(".drawer-menu").hasClass('drawer-show'))
                U.close_all();
            else {
                $(".menubg").addClass('show');
                $(".drawer-menu").addClass('drawer-show');
                $(".screen-main").animate({scrollTop: 0}, 0);
                MAINMENU.load_catalog_menu(function () {});
            }
        });

        $(".sidebar__menu .sub >a").click(function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.parent().toggleClass('opened');
        });

        if ($(".sidebar__menu a").length) {
            if (document.location.pathname.substr(0, 5) == '/blog' || document.location.pathname.substr(0, 8) == '/ru/blog')
                $(".sidebar__menu a[href*=blog]").parent().addClass('active');

            $.each($(".sidebar__menu a"), function (i, item) {
                item = $(item);

                if (document.location.pathname == item.attr('href')) {
                    item.parent().addClass('active');

                    if (item.parents('.sub').length) {
                        item.parents('.sub').addClass('active').addClass('opened');
                    }
                }

            });
        }

        jQuery("body").on("click", ".blog__main .show-more", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let page = parseInt(btn.data('page')) + 1;
            btn.data('page', page);
            let topposition = $(document).scrollTop();

            $.post(
                document.location.pathname,
                {
                    action: 'blog',
                    page: page,
                },
                function (result) {
                    $(".blog__list").append(result.html);
                    $(".pagination").replaceWith(result.pagination);
                    $(document).scrollTop(topposition);
                },
                'json'
            )
        });

        jQuery("body").on("click touchend", ".menubg, .menubg-contain, .drawer__close, .cart .close, .tooltip-mobile .pseudo, .js-closepopups, .workdrawer >.close", function (e) {
            e.preventDefault();
            U.close_all();
        });

        jQuery("body").on("click", ".screen__back", function (e) {
            e.preventDefault();
            $(".drawer >.screen").remove();
            $(".drawer .screen-main").removeClass('collapsed');
        });

        jQuery("body").on("click", ".drawer__menuitem-catalog .drawer__menuli > a, .drawer__menuli-city > a", function (e) {
            e.preventDefault();
            let btn = $(this).parent();

            console.trace();

            MAINMENU.prevent_submenu();

            if ($(this).parents('.drawer__menuli-city').length > 0)
                CITY.load_popup(function () {
                    MAINMENU.open_catalog_submenu(btn);
                });
            else
                MAINMENU.open_catalog_submenu(btn);
        });

        jQuery("body").on('click touchend', ".open-tooltip", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);

            if (U.isMobile() && btn.parents('.product__top').length > 0 && btn.parent().hasClass('methods')) {
                $(".buy-in-credit-btn").trigger('click');
            } else {
                let data = btn.data();

                if (btn.data('toggle') && btn.hasClass(btn.data('toggle'))) {
                    TOOLTIP.hide();
                    return;
                }

                if (btn.hasClass('open-tooltip-simple')) {
                    data = {
                        target: 'self'
                    };
                }

                TOOLTIP.open(btn, data);
            }
        });

        jQuery("body").on('click touchend', ".black-tooltip", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let data = btn.data();
            data.subclass = 'tooltip-black';
            data.target = 'black';
            data.place = data.place ?? 'topright';
            TOOLTIP.open(btn, data);
        });

        jQuery("body").on('click touchend', ".tooltip__close", function (e) {
            e.preventDefault();
            e.stopPropagation();
            TOOLTIP.hide();
        });

        if (!U.isMobile()) {
            jQuery("body").on('mouseover', ".hover-tooltip", function (e) {
                let btn = $(this);
                TOOLTIP.remove();

                if (btn.hasClass('ri-compare')) {
                    COMPARSION.hover(btn);
                } else {
                    TOOLTIP.open(btn, btn.data());
                }
            });

            jQuery("body").on('mouseout', ".hover-tooltip", function (e) {
                let btn = $(this);
                if (!(btn.hasClass('ri-wishlist-active') || btn.hasClass('ri-compare-active')))
                    $(".tooltip-wishlist, .tooltip-compare").fadeOut(100, function () {
                        $(this).remove();
                    });
            });
        }

        jQuery("body").on('click', ".city-selector", function (e) {
            e.preventDefault();
        });

        if (!U.isMobile()) {
            jQuery("body").on('mouseover touch', ".drawer__menuli >a", function (e) {
                MAINMENU.show_submenu($(this));
            }).on('mouseleave', ".drawer__menuli >a", function (e) {
                MAINMENU.prevent_submenu();
            });
        }

        // open mobile service
        $(".open-service").click(function (e) {
            e.preventDefault();
            let btn = $(this);
            let append = $('<div class="screen"><div class="top"><a href="javascript: void(null);" class="close icon-close"></a></div><div class="menu gtm-menu" data-parent="' + btn.text() + '" data-id="menu' + (G.locale_id ? '1' : '') + '3"></div></div>');

            $(".drawer >.screen").remove();
            $(".drawer .screen-main").addClass('collapsed');

            append.find('.top').append('<a href="#" class="go-back">' + btn.text() + '</a>');

            let result = '';
            let selector = $("footer .menu .service ul");

            if (selector.length) {
                selector = selector.clone();
                selector.addClass("noicon");
                result = selector;
            }

            append.find('.menu').append(result);
            append.find('.menu >ul').data('parent', btn.text());
            append.appendTo($(".drawer")).addClass('visible');
        });

        // open mobile support
        $(".open-support").click(function (e) {
            e.preventDefault();
            let btn = $(this);
            let append = $($('.support-screen').html());

            $(".drawer >.screen").remove();
            $(".drawer .screen-main").addClass('collapsed');

            append.appendTo($(".drawer")).addClass('visible');
        });

        // open mobile im
        $(".open-im").click(function (e) {
            e.preventDefault();
            let btn = $(this);
            let append = $('<div class="screen"><div class="top"><a href="javascript: void(null);" class="close icon-close"></a></div><div class="menu gtm-menu" data-parent="' + btn.text() + '" data-id="menu' + (G.locale_id ? '1' : '') + '6"></div></div>');

            $(".drawer >.screen").remove();
            $(".drawer .screen-main").addClass('collapsed');

            append.find('.top').append('<a href="#" class="go-back">' + btn.text() + '</a>');

            let result = '';
            let selector = $("footer .menu .ishop ul");

            if (selector.length) {
                selector = selector.clone();
                selector.addClass("noicon");
                result = selector;
            }

            append.find('.menu').append(result);
            append.find('.menu >ul').data('parent', btn.text());
            append.appendTo($(".drawer")).addClass('visible');
        });

        jQuery("body").on("click", ".go-back", function (e) {
            e.preventDefault();

            let btn = $(this);
            let left = $(".drawer .screen").length - 1;

            btn.parents('.screen').removeClass('visible').animate({background: 'none'}, 200, function () {
                $(this).remove();
            });

            $(".drawer .screen" + (left ? '' : '-main')).removeClass('collapsed');
        });

        jQuery("body").on("click", ".city-selector a", function (e) {
            let btn = $(this);

            $(`.shops-list li`).addClass('hidden');
            $(`.shops-list li[data-city_id=${btn.data('id')}]`).removeClass('hidden');

            TOOLTIP.hide();

            return;

            $.post(
                '/aj',
                {
                    action: 'u',
                    to: 'citychange',
                    url: btn.data('url'),
                    locale: G.locale_id
                },
                function (data) {
                    $("body .tooltip").removeClass('show');
                    setTimeout(function () {
                        $("body .tooltip").remove();
                    }, 500);

                    $(".change-city").text(btn.text());
                    $(".shops-list").empty();

                    if (typeof data.cities === "object")
                        $.each(data.cities, function (i, item) {
                            $(".shops-list").append('<li><a href="' + item.url + '"><span class="go-right2">' + __('Магазин') + ' «' + item.type + '»</span><small>' + item.address + '</small></a></li>');
                        })
                },
                'json'
            );
        });

        /* Stores */
        jQuery("body").on("click touchend", ".store__list .call a", function (e) {
            e.stopPropagation();
            return true;
        });

        jQuery("body").on("click touchend", ".js-store__bundle", function (e) {
            e.preventDefault();
            let btn = $(this);
            let container = $(this);

            if (container.hasClass('loading'))
                return;

            if (U.isMobile())
                $(".store__content").insertAfter(btn);

            container.addClass('loading');

            $.ajax({
                type: "POST",
                url: "/aj",
                data: {
                    to: 'store',
                    action: 'stores',
                    id: container.data('id'),
                    city: container.data('city'),
                    locale: G.locale_id
                },
                dataType: "json",
                timeout: 5000, // in milliseconds
                success: function (data) {

                    if (!(typeof data.title === "undefined")) {
                        $("title").html(data.title);
                        $(".store__title").html(data.title);
                    }

                    $(".store__list >.active").removeClass('active');
                    let html = $(data.html);

                    container.removeClass('loading').addClass('active');

                    $(".store-inner").html(html.find('.store-inner').html());
                    $(".map").html(html.find('.map').html());
                    U.init_full_size_gallery();
                    U.fix_store_content();

                    try {
                        if (G.map == '' && G.use_smart_map)
                            initialize();
                    } catch (e) {
                    }

                    // pageview
                    history.pushState({}, null, data.url);
                    GTM.event('pageview', data.url);

                    if (G.use_smart_map)
                        try {
                            G.map.setCenter({
                                lat: btn.data('lat'),
                                lng: btn.data('lng')
                            });
                            G.map.setZoom(btn.data('zoom'));
                        } catch (e) {
                        }

                },
                error: function (data) {
                    container.removeClass('loading');
                }
            });

        });

        jQuery("body").on("keyup", ".store__contain input", function (e) {
            var input = $(this);

            if ($.trim(input.val()) == '') {
                $(".store__list >.store__bundle").removeClass('hidden');
            } else {
                var query = $.trim(input.val());
                $.each($(".store__list >.store__bundle"), function (i, item) {
                    item = $(item);
                    if (item.find(".title").text().toLowerCase().indexOf(query) !== -1)
                        item.removeClass('hidden');
                    else
                        item.addClass('hidden')
                })
            }
        });

        jQuery("body").on("click touchend", ".store-page .blog-categories a", function (e) {
            e.preventDefault();

            var btn = $(this);
            $(".store-page .blog-categories a").removeClass('active');
            btn.addClass('active');
            $(".store__list >div:not(.store__content):not([data-city=" + btn.data('city') + "])").addClass('hidden');
            $(".store__list >div[data-city=" + btn.data('city') + "]").removeClass('hidden');
            $(".store__list >.active").removeClass('active');

            $.ajax({
                type: "POST",
                url: "/aj",
                data: {
                    to: 'city',
                    action: 'stores',
                    city: btn.data('city'),
                    locale: G.locale_id
                },
                dataType: "json",
                timeout: 5000, // in milliseconds
                success: function (data) {
                    $(".store-inner").html('');
                    $(".store__list .store__content").insertBefore($(".store__list >div:not(.store__content):eq(0)"))

                    if (G.use_smart_map) {
                        try {
                            if (G.map == '' && G.use_smart_map)
                                initialize();
                        } catch (e) {
                        }

                        try {
                            G.map.setCenter({
                                lat: btn.data('lat'),
                                lng: btn.data('lng')
                            });
                            G.map.setZoom(btn.data('zoom'));
                        } catch (e) {
                        }
                    } else {
                        $(".store__list >div[data-city=" + btn.data('city') + "]:eq(0)").trigger('click');
                    }
                }
            });

            history.pushState({}, null, btn.attr('href'));
            GTM.event('pageview', btn.attr('href'));
        });

        jQuery("body").on("click", ".blog-categories.container-lastseen a", function (e) {
            e.preventDefault();

            var btn = $(this);
            var context_id = btn.data('context');

            $(".blog-categories.container-lastseen a").removeClass('active');
            btn.addClass('active');

            if (context_id == 0)
                $(".looplist .loop").removeClass('hidden');
            else {
                $(".looplist .loop").addClass('hidden');
                $(".looplist .loop[data-context=" + context_id + "]").removeClass('hidden');
            }

            if ($(".looplist .loop img:not(.loaded)").length)
                $.each($(".looplist .loop img:not(.loaded)"), function (i, img) {
                    img = $(img);
                    img.addClass('loaded').attr('src', img.data('lazycatalog'));
                })
        });

        jQuery("body").on("click touchend", ".loop .slr-availability a.point, .product .slr-availability a.point, .product__availability-manager a, .product__oppoitem-shop.open-tooltip", function (e) {
            e.preventDefault();
            let btn = $(this);
            let id = btn.data('id');
            let sku = btn.data('sku');

            if (btn.hasClass('havent'))
                return false;

            $.post(
                '/aj',
                {
                    action: G.manager_logged ? 'slr' : 'goods',
                    to: G.manager_logged ? 'availability' : 'stores',
                    sku: sku,
                    locale: G.locale_id
                },
                function (data) {
                    $(".availability__contain").removeClass('load-animation').append(data.data);
                },
                'json'
            );
        });

        $(".change-search").click(function (e) {
            e.preventDefault();
            $(".searchform input[name=q]").val($(".search-phrase").data('val') + ' ').trigger('focus').trigger('keyup');
        });

        if (typeof empty_search === "number")
            setTimeout(function () {
                $(".searchform input[name=q]").trigger('focus')
            }, 300);

        setTimeout(function () {
            U.fix_store_content();
        }, 300);

        $(window).trigger('scroll');

        switch (G.command) {
            case 'blackfriday':
                GTM.fireStatistick('statistick', 'click', 'BF сторінка', '');
                break;

            case 'page_lastseen':
                BROWSE.lastseen();
                break;

            case 'openauth':
                $(".openloginform").trigger('click');
                break;

            case 'compare':
                COMPARSION.load_page();
                break;

            case 'publiccompare':
                COMPARSION.load_from_url();
                COMPARSION.load_page();
                break;

            case 'wishlist':
                WISHLIST.load_page();
                break;

            case 'forceOnLoad':
                $(".send_form").submit(function(e){
                    e.preventDefault();

                    let form = $(this);
                    let response = grecaptcha.getResponse();

                    if (response.length)
                        $.post(
                            '/',
                            form.serialize() + '&captcha_success=' + response.length,
                            function(data) {
                                if (data.success)
                                    document.location.reload();
                            },
                            'json'
                        );
                });
                break;
        }

        jQuery("body").on("click", ".comparsion__table .separator >div", function (e) {
            e.preventDefault();
            let parent = $(this).parent();
            $(".separator[data-id=" + parent.data('id') + "]").toggleClass('closed');
        });

        jQuery("body").on("click", ".js-ctabs__a-comparsion", function (e) {
            e.preventDefault();
            let btn = $(this);
            COMPARSION.load_page(btn.data('id'));

            if ($("body .tooltip").length) {
                $("body .tooltip").removeClass('show');
                setTimeout(function () {
                    $("body .tooltip").remove();
                }, 500);
            }
        });

        jQuery("body").on("click", ".js-comparsion__remove", function (e) {
            e.preventDefault();
            let btn = $(this);
            let context_id = $(".comparsion__top .ctabs__a-active").data('id');
            COMPARSION.remove(btn.parents('.item').data('sku'));
            COMPARSION.load_page(context_id);
        });

        jQuery("body").on("click", ".js-comparsion__remove-public", function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.parents('.item').remove();

            let skus = [];
            let url = document.location.pathname.split('/compare/');

            if ($(".comparsion__table .item").length)
                $.each($(".comparsion__table .item"), (i, item) => {
                    item = $(item);
                    skus.push(item.data('sku'));
                });

            history.pushState({}, null, `${url[0]}/compare/${skus.join(',')}`);
            COMPARSION.load_from_url();
            COMPARSION.load_page();
        });

        jQuery("body").on("click", ".comparsion__cleanall, .comparsion__cleanlist", function (e) {
            e.preventDefault();
            let btn = $(this);

            if (btn.hasClass('comparsion__cleanlist'))
                COMPARSION.clean_context($(".comparsion__top .ctabs__a-active").data('id'), function () {
                    COMPARSION.load_page();
                });
            else {
                COMPARSION.clean();
                COMPARSION.load_page();
            }
        });

        jQuery("body").on("click", ".ri-wishlist, .wishlist-icon", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            TOOLTIP.remove();

            if (USER.is_logged() || G.b2bmode || G.manager_logged) {

                if (btn.hasClass('ri-wishlist-active')) {
                    WISHLIST.remove(btn.data('sku'));

                    if ($(".wishlist-goods").length)
                        WISHLIST.load_page();
                } else {
                    let button = btn.parents('.loop').length ? btn.parents('.loop').find('.loop__title') : btn.parents('.product__top').find('.product__priceinner .buy');
                    WISHLIST.add(btn.data('sku'), button);

                    if ($(".wishlist-goods").length)
                        WISHLIST.load_page();
                    else
                        TOOLTIP.open(btn, {
                            target: '.ri__wishlisthover-filled',
                            place: 'bottom',
                            subclass: 'tooltip-wishlist'
                        });

                }
            } else {
                let button = btn.parents('.loop').length ? btn.parents('.loop').find('.loop__title') : btn.parents('.product__top').find('.product__priceinner .buy');

                if (button)
                    GTM.event('add_to_wishlist', button, 0, 'wishlist', '');

                TOOLTIP.remove();
                TOOLTIP.open($(this), {
                    target: '.closed-wishlist',
                    place: btn.hasClass('wishlist') ? 'top' : 'bottom',
                    subclass: 'credit wishlist'
                });
            }

        });

        jQuery("body").on("click", ".catalog-mode a", function (e) {
            e.preventDefault();
            Cookies.set("catalog_mode", $(this).data('val'), {
                path: '/'
            });
            document.location.reload();
        });

        COMPARSION.update_anchors();
        WISHLIST.update_anchors();

        if (Cookies.get("after_social_auth")) {
            COMPARSION.synchronize(0, function () {
                COMPARSION.update_anchors();
                Cookies.remove('after_social_auth');
            });
            WISHLIST.synchronize('', 'updateall', function () {
                WISHLIST.update_anchors();
                Cookies.remove('after_social_auth');
            });
        }

        jQuery("body").on("click", ".js-open-supportman", function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (U.isMobile() && $(".drawer-menu").hasClass('drawer-show'))
                $(".drawer__close").trigger('click');

            $(".open-supportman").trigger('click');
        });

        jQuery("body").on("click", ".open-supportman", function (e) {
            e.preventDefault();
            $(".open-supportman").removeClass('show');

            if ($(this).hasClass('open-supportman-triggerchat')) {
                $(this).removeClass('open-supportman-triggerchat')
                $(".open-verbox-chat").trigger('click');
            } else {
                TOOLTIP.open($(this), {
                    target: '.supportman-menu',
                    place: 'top',
                    subclass: 'support-menu',
                    remove_onscroll: true
                });
            }
        });

        jQuery("body").on("mouseover", ".open-supportman", function (e) {
            e.preventDefault();

            if ($(".support-menu").length)
                $(this).removeClass('show');
            else
                $(this).addClass('show');
        });

        jQuery("body").on("mouseout", ".open-supportman", function (e) {
            e.preventDefault();
            $(this).removeClass('show').removeClass('hover');
        });

        var supportman_timeout = parseInt(Cookies.get("open_supportman"));
        supportman_timeout = typeof supportman_timeout === "number" && supportman_timeout > 0 ? supportman_timeout : 0;
        supportman_timeout = supportman_timeout > 2 ? 0 : (supportman_timeout + 1) * 30000;

        if (supportman_timeout) {
            setTimeout(function () {
                let current_val = parseInt(Cookies.get("open_supportman"));
                current_val = typeof current_val === "number" && current_val > 0 ? current_val : 0;
                if (!$(".open-supportman").hasClass('show')) {
                    $(".open-supportman").addClass('hover').addClass('show');
                    Cookies.set("open_supportman", current_val + 1, {
                        path: '/'
                    });

                    setTimeout(function () {
                        if ($(".open-supportman").hasClass('hover'))
                            $(".open-supportman").removeClass('hover').removeClass('show');
                    }, 10000);
                }

            }, supportman_timeout);
        }

        // edit count +
        jQuery("body").on("click", ".go-top", function (e) {
            e.preventDefault();
            let body = $("html, body");
            body.stop().animate({scrollTop: 0}, '200', 'swing');
        });

        if (U.isMac())
            $(".icon-imessage").removeClass('hidden');

        KE.init();

        jQuery("body").on('click', '.user-store-banner >div .remove', function (e) {
            e.preventDefault();

            if (confirm('Показати наявність по всій мережі ?')) {
                Cookies.remove('store_id', {path: '/'});
                document.location.reload();
            }
        });

        jQuery("body").on('click', '.loop .bonus, .product__top .bonuses-amount', function (e) {
            e.preventDefault();
            e.stopPropagation();

            TOOLTIP.open($(this), {
                target: '.bonus-description',
                place: 'top',
                subclass: 'bonus-description credit',
            });
        });

        jQuery("body").on('click', ".header__menu a[href='#catalog']", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(".menu__toggle").trigger('click');
        });

        // hash
        if (document.location.hash == '#orderform') {
            history.pushState({}, null, document.location.pathname);
            CARD.clickgopay = true;
            CARD.open()
                .then(() => {
                    CARD.updatePromise()
                }).then(() => {
                CARD.open_checkout()
            });
        }

        if (document.location.hash.substring(0, 13) == '#orderstatus_') {
            CARD.check_order(document.location.hash.replace(/#orderstatus_/i, ''));
            history.pushState({}, null, document.location.pathname);
        }

        if (document.location.hash == '#complain2chief') {
            $(".write-main-btn").trigger('click');
        }

        jQuery("body").on('click', '.promo__tagnav', function (e) {
            e.preventDefault();
            let btn = $(this);
            let next = 1;

            CATALOG.reset_promo_slider();

            if (btn.hasClass('promo__tagnav-down')) {
                if ($(".promo__taglist .promo__tag-active").next().index() >= 0)
                    next = $(".promo__taglist .promo__tag-active").next().index();
                else
                    next = 0;
            } else {
                if ($(".promo__taglist .promo__tag-active").prev())
                    next = $(".promo__taglist .promo__tag-active").prev().index();
                else
                    next = $(".promo__taglist .promo__tag").length - 1;
            }

            $(".promo__taglist .promo__tag-active").removeClass('promo__tag-active');
            $(".promo__taglist .promo__tag:eq(" + next + ")").addClass('promo__tag-active');

            $(".promo__tagcount").html(($(".promo__taglist .promo__tag-active").index() + 1) + '/' + $(".promo__taglist .promo__tag").length);

            U.send_impressions();
        });

        CATALOG.reset_promo_slider();

        // copy text
        jQuery("body").on('click touchend', '.js-copytext', function (e) {
            e.preventDefault();

            let btn = $(this);
            U.copyToClipboard(btn.data('text') ? btn.data('text') : btn.text());
            WARNING.info(__('Текст скопійовано'));
        });

        jQuery("body").on('click', '.warning', function (e) {
            e.preventDefault();
            $(this).stop().fadeOut('normal', function () {
                $(this).remove()
            });
        });

        if (!U.isMobile()) {
            // loophover
            $("body").on('mouseover', '.loop', function (e) {
                e.preventDefault();
                let target = $(e.target);

                if (target.hasClass('loop__container')) {
                    LOOP.clean_timeout();
                    let btn = $(this);

                    if (btn.hasClass('loop-hovered'))
                        return;

                    btn.addClass('loop-hovered');

                    let imagesPromise = new Promise((resolve, reject) => {
                        if (btn.hasClass('loop-imagesloading')) {
                            reject();
                        } else {
                            if (btn.hasClass('loop-imagesloaded')) {
                                resolve();
                            } else {
                                btn.addClass('loop-imagesloading');
                                fetch('/u/loadimages', {
                                    method: 'POST',
                                    mode: 'cors',
                                    cache: 'no-cache',
                                    credentials: 'same-origin',
                                    headers: {
                                        'Content-Type': 'application/x-www-form-urlencoded'
                                    },
                                    redirect: 'follow',
                                    referrerPolicy: 'no-referrer',
                                    body: new URLSearchParams({
                                        sku: btn.find('.loop__image').data('sku')
                                    })
                                })
                                    .then((response) => response.json())
                                    .then((data) => {
                                        btn.removeClass('loop-imagesloading');
                                        btn.addClass('loop-imagesloaded');

                                        if (data.length > 0) {
                                            data.map((imageurl) => {
                                                $(".loop__image", btn).append(`<picture class="loop__picture hidden" style="opacity: 0">
                                                <source srcset="${imageurl}">
                                                <img loading="lazy" >
                                            </picture>`);
                                            });
                                        }

                                        resolve();
                                    });
                            }
                        }
                    });

                    imagesPromise.then(() => {
                        if (btn.find('picture').length > 1) {
                            LOOP.start_timeout(btn);
                        }

                    })
                }
            });

            jQuery("body").on("mouseout", ".loop", function (e) {
                let target = $(e.target);

                if (target.hasClass('loop__container')) {
                    let btn = $(this);
                    btn.removeClass('loop-hovered');
                    LOOP.clean_timeout();

                    if (btn.find('picture').length > 1) {
                        btn.find('picture').addClass('hidden').css({
                            opacity: 0
                        });

                        btn.find('picture:eq(0)').removeClass('hidden').css({
                            opacity: 1
                        });
                    }
                }
            });
        }

        // loop mouse out
        $("body").on('mouseleave', '.loop', function (e) {
            e.preventDefault();
            let loop = $(this);

            if (loop.data('old_image'))
                loop.find('source').attr('srcset', loop.data('old_image'));
        });

        // drawer
        $("body").on('click', '.workdrawer >.close', function (e) {
            e.preventDefault();
            DRAWER.destroy();
        });

        // sharebtn
        $("body").on('click', '.js__sharebtn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            U.share($(this).data('url'), $(this));
        });

        // sharebtn
        $("body").on('click', '.js__comparsion__savetome', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            COMPARSION.addpack(COMPARSION.sku_from_url());
            TOOLTIP.open(btn, {
                place: 'top',
                subclass: 'tooltip-black text-center tooltip-fadeinout',
                target: 'black',
                fadeinout: true
            });
        });

        // $("body").on('keyup', '.js-form__input-checkukr', function (e) {
        //     let input = $(this);
        //     console.log(input.val());
        //     return;
        //     // let input = $(this);
        //     // let container = input.parent();
        //     // let myRegEx = /^[а-яА-ЯЄєйЙїЇіІьЬ\s\'\-]*$/i;
        //     //
        //     // if (myRegEx.test(input.val()) || input.val()=='') {
        //     //     container.removeClass('form-item-error');
        //     // } else {
        //     //     container.addClass('form-item-error');
        //     // }
        // });

        $("body").on('keypress', '.js-form__input-checkukr', function (e) {
            let input = $(this);
            let val = e.key;
            let container = input.parent();
            let myRegEx = /^[а-яА-ЯЄєйЙїЇіІьЬ\s\'\-]*$/i;

            console.log(val, input.val());

            if (e.code=='Backspace' || e.code=='Space' || e.code=='Tab') {
                return;
            }

            if (myRegEx.test(val)) {
                container.removeClass('form-item-error');
                container.find('span.red').addClass('hidden');
                return true;
            } else {
                e.preventDefault();
                container.addClass('form-item-error');
                container.find('span.red').removeClass('hidden').text('Використовуйте лише кирилицю');
                return false;
            }
        });

        $("body").on('keypress', '.js-form__input-checkukrlight', function (e) {
            let input = $(this);
            let val = e.key;
            let container = input.parent();
            let myRegEx = /^[0-9а-яА-ЯЄєйЙїЇіІьЬ\s\/\-]*$/i;

            console.log(val, input.val());

            if (e.code=='Backspace' || e.code=='Space' || e.code=='Tab') {
                return;
            }

            if (myRegEx.test(val)) {
                container.removeClass('form-item-error');
                container.find('span.red').addClass('hidden');
                return true;
            } else {
                e.preventDefault();
                container.addClass('form-item-error');
                container.find('span.red').removeClass('hidden').text('Використовуйте лише кирилицю');
                return false;
            }
        });

        // chat
        CHAT.check_messages();

        jQuery("body").on("click", ".open-verbox-chat", function (e) {
            e.preventDefault();
            let btn = $(this);
            let message = '';

            if (btn.parents('.tooltip').length > 0) {
                let tooltip = btn.parents('.tooltip');
                if (tooltip.find('.order__questiontooltiptext').length > 0) {
                    message = tooltip.find('.order__questiontooltiptext').text();
                }
            }

            CHAT.open(message);
        });

        // search
        jQuery("body").on('click', '.js-search__switchtab', function(e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            SEARCH.load_tab(btn.data('tab'));
        });

        // search
        jQuery("body").on('click', '.js-search__tabshowmore', function(e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            SEARCH.load_tab(btn.data('tab'), parseInt(btn.data('offset')));
        });

        if (U.isMobile()) {
            $(".searchform input[name=mobile]").val(1);
        }

    });

    if ($(".event__headerp__leftt").length > 0) {
        setInterval(() => {
            const index = $(".event__headerp__leftt.visible").index();
            const new_index = index == 2 ? 0 : index + 1;
            $(".event__headerp__leftt.visible, .event__headerp__rightt.visible").removeClass('visible');
            $(`.event__headerp__leftt:eq(${new_index}), .event__headerp__rightt:eq(${new_index})`).addClass('visible');
        }, 5000);
    }

    // check
    jQuery("body").on("click", ".js-popup__bonus200-approve", function (e) {
        e.preventDefault();
        let btn = $(this);
        if (btn.hasClass('active')) {
            btn.find('small').removeClass('active');
            btn.find('input').val(0);
        } else {
            btn.find('small').addClass('active');
            btn.find('input').val(1);
        }
    });

    jQuery("body").on("keyup change", ".js-popup__bonus200-form input, .js-popup__bonus200-form textarea", function (e) {
        const form = $(this).parents('.js-popup__bonus200-form');
        const phone = form.find("[name=login]");

        if (
            !($.trim(form.find('[name=name]').val()) == '') &&
            U.validate_email(form.find('[name=email]').val()) &&
            phone.val().replace(/[^\d]/g, '').length==10 &&
            form.find('[name=allow]').prop('checked')
        ) {
            form.find('.alert').addClass('hidden');
            form.find('[type=submit]').addClass('active');
        } else {
            form.find('[type=submit]').removeClass('active');
        }
    });

    jQuery("body").on('submit', '.js-popup__bonus200-form', function (e) {
        e.preventDefault();
        const form = $(this);

        let errors = 0;
        const name = form.find('[name=name]');
        const email = form.find('[name=email]');
        const phone = form.find('[name=login]');
        const allow = form.find('[name=allow]');
        const btn = $(this).find('[type=submit]');

        if (form.find('[type=submit]').hasClass('loading'))
            return;

        if ($.trim(name.val()) == '') {
            name.addClass('error');
            errors++;
        } else {
            name.removeClass('error');
        }

        if (!(phone.val().replace(/[^\d]/g, '').length==10)) {
            name.addClass('error');
            errors++;
        } else {
            name.removeClass('error');
        }

        if ($.trim(email.val()) == '' || !U.validate_email(email.val())) {
            email.addClass('error');
            errors++;
        } else {
            email.removeClass('error');
        }

        if (allow.prop('checked')) {
            email.removeClass('error');
        } else {
            allow.addClass('error');
            errors++;
        }

        if (errors == 0) {
            form.find('[type=submit]').addClass('loading');
            form.find('.alert').addClass('hidden');

            $.post(
                '/aj',
                {
                    action: 'popup',
                    to: 'bonus200send',
                    page: document.location.href,
                    name: form.find('[name=name]').val(),
                    phone: form.find('[name=login]').val(),
                    email: form.find('[name=email]').val(),
                },
                function (data) {
                    if (data.success) {

                        $(".js-popup__bonus200-first").addClass('hidden');
                        $(".js-popup__bonus200-second").removeClass('hidden');
                        USER.send_sms('auth', '.js-popup__bonus200-form');
                    } else {
                        form.find('.alert').html(data.message).removeClass('hidden');
                    }

                    form.find('[type=submit]').removeClass('loading');
                },
                'json'
            );
        } else {
            form.find('.alert').html('Поля ім\'я, email, телефон та ваша згода є обов\'язковими').removeClass('hidden');
            return;
        }

        return false;
    });

    jQuery("body").on('click', '.js-popup__bonus200-open', function(e){
        e.preventDefault();
        e.stopPropagation();
        const btn = $(this);
        console.log('js-popup__bonnus200-open');

        GTM.fireStatistick('statistick', 'click', 'getcontacts_form', '');

        DRAWER.init('workdrawer-popup-bonus200 workdrawer-full', {
            action: 'popup',
            to: 'bonus200'
        }, function () {
            U.mask_inputs()
        });
    });

    jQuery("body").on('click', '.js-popup__bonus200-close', function(e){
        e.preventDefault();
        e.stopPropagation();
        const btn = $(this);

        Cookies.set("popup__bonnus200closed", 1, {
            path    : '/',
        });

        btn.parent().remove();
    });

    if (G.show_bonus200 !== undefined) {
        setTimeout(() => {
            $(".js-popup__bonus200-open").removeClass('hidden');

            GTM.fireStatistick('statistick', 'click', 'getcontacts_popup', '');
        }, G.show_bonus200);
    }

    if ($(".bonus200").length > 0) {
        GTM.fireStatistick('statistick', 'click', 'getcontacts_done', '');
    }

    jQuery("body").on('click', '.decor-banner a', function(e){
        const btn = $(this);

        Cookies.set("clicked_banner", btn.data('id'), {
            path    : '/',
        });
    });

    jQuery("body").on('click', '.js-popup__ediloform', function(e){
        e.preventDefault();
        const btn = $(this);

        U.loadscript("https://web.edilo.com.ua/edilo_integration_form.js", function() {
            GTM.fireStatistick('statistick', 'click', 'Відкриття форми eDilo', btn.text());
            showEdiloForm({});
        });
    });

    // event happy birthday
    jQuery("body").on('click', '.js-event__giftone', function(e){
        e.preventDefault();
        let btn = $(this);
        let phone = '';
        let logged = G.client !== undefined;

        if (logged) {
            phone = G.client.phone;
        }

        if (logged && phone) {
            btn.find('.event__giftone-img').addClass(`event__giftone-img-${btn.data('val')}-boom`);

            // random gift
            fetch('/newyear2026.html', {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer'
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.success) {
                        if (data.type=='bonus') {
                            $(".js-event__bonuscount").html(data.count);
                        } else {
                            $(".js-event__selectedpromocode").html(data.promocode);
                        }

                        $(".event__giftselect").fadeOut('fast');
                        $(`.event__gift${data.type}`).removeClass('hidden').addClass('puff-in-center');
                        $(".event__giftouter").addClass(`event__giftouter-${data.type}`);
                    } else {
                        throw new Error(data.message);
                    }
                })
                .catch((data) => {
                    alert(data);
                });
        } else {
            if (logged) {
                // need phone
                setTimeout(() => {
                    $(".event__giftselect").addClass('hidden');
                    $(".event__giftphoneauth").removeClass('hidden');
                }, 500);
            } else {
                setTimeout(() => {
                    $(".event__giftselect").addClass('hidden');
                    $(".event__giftauth").removeClass('hidden');
                }, 500);
            }
        }
    });

}